var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 466.23 161.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146,.cls-147,.cls-148,.cls-149,.cls-150,.cls-151,.cls-152,.cls-153,.cls-154,.cls-155,.cls-156,.cls-157,.cls-158,.cls-159,.cls-160,.cls-161,.cls-162,.cls-163,.cls-164,.cls-165,.cls-166,.cls-167,.cls-168,.cls-169,.cls-170,.cls-171,.cls-172,.cls-173,.cls-174,.cls-175,.cls-176,.cls-177,.cls-178,.cls-179,.cls-180,.cls-181,.cls-182,.cls-183,.cls-184,.cls-185,.cls-186,.cls-187,.cls-188,.cls-189,.cls-190,.cls-191,.cls-192,.cls-193,.cls-194,.cls-195,.cls-196,.cls-197,.cls-198,.cls-199,.cls-200,.cls-201,.cls-202,.cls-203,.cls-204{stroke-width:0px;}.cls-2{fill:url(#linear-gradient-29);}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-205{opacity:.5;}.cls-3{fill:url(#linear-gradient-31);}.cls-4{fill:url(#linear-gradient-33);}.cls-5{fill:url(#linear-gradient-13);}.cls-6{fill:url(#linear-gradient-15);}.cls-7{fill:url(#New_Gradient_Swatch_4);}.cls-8{fill:url(#New_Gradient_Swatch_3);}.cls-206{mask:url(#mask-15);}.cls-207{mask:url(#mask-17);}.cls-208{mask:url(#mask-14);}.cls-209{mask:url(#mask-13);}.cls-210{mask:url(#mask-12);}.cls-211{mask:url(#mask-11);}.cls-212{mask:url(#mask-16);}.cls-213{mask:url(#mask-10);}.cls-214{filter:url(#luminosity-noclip-9);}.cls-215{filter:url(#luminosity-noclip-7);}.cls-216{filter:url(#luminosity-noclip-3);}.cls-217{filter:url(#luminosity-noclip-5);}.cls-9{fill:url(#linear-gradient-28);}.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-42,.cls-218,.cls-182,.cls-185,.cls-202,.cls-204{mix-blend-mode:multiply;}.cls-10{fill:url(#linear-gradient-30);}.cls-11{fill:url(#linear-gradient-32);}.cls-12{fill:url(#linear-gradient-34);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-22);}.cls-16{fill:url(#linear-gradient-20);}.cls-17{fill:url(#linear-gradient-18);}.cls-18{fill:url(#linear-gradient-17);}.cls-19{fill:url(#linear-gradient-16);}.cls-20{fill:url(#New_Gradient_Swatch_3-3);}.cls-21{fill:url(#New_Gradient_Swatch_3-4);}.cls-22{fill:url(#New_Gradient_Swatch_3-9);}.cls-23{fill:url(#New_Gradient_Swatch_3-8);}.cls-24{fill:url(#New_Gradient_Swatch_3-7);}.cls-25{fill:url(#New_Gradient_Swatch_3-6);}.cls-26{fill:url(#New_Gradient_Swatch_3-2);}.cls-27{fill:url(#New_Gradient_Swatch_3-5);}.cls-28{fill:url(#New_Gradient_Swatch_4-2);}.cls-219{mask:url(#mask);}.cls-29{fill:url(#linear-gradient);}.cls-220{filter:url(#luminosity-noclip);}.cls-30{fill:url(#radial-gradient);}.cls-31{fill:#ef4136;}.cls-32{fill:#6d6e71;}.cls-33{fill:#f15a29;}.cls-34{fill:url(#linear-gradient-36);}.cls-35{fill:url(#linear-gradient-35);}.cls-36{fill:url(#linear-gradient-25);}.cls-37{fill:url(#linear-gradient-11);}.cls-38{fill:url(#linear-gradient-10);}.cls-39{fill:url(#linear-gradient-27);}.cls-40{fill:url(#linear-gradient-24);}.cls-41{fill:url(#linear-gradient-26);}.cls-42,.cls-181{fill:#000;}.cls-221{filter:url(#luminosity-noclip-17);}.cls-222{filter:url(#luminosity-noclip-15);}.cls-223{filter:url(#luminosity-noclip-13);}.cls-224{filter:url(#luminosity-noclip-11);}.cls-43{fill:#bcbec0;}.cls-44{fill:url(#New_Gradient_Swatch_3-12);}.cls-45{fill:url(#New_Gradient_Swatch_3-11);}.cls-46{fill:url(#New_Gradient_Swatch_3-10);}.cls-47{fill:url(#New_Gradient_Swatch_3-21);}.cls-48{fill:url(#New_Gradient_Swatch_3-27);}.cls-49{fill:url(#New_Gradient_Swatch_3-28);}.cls-50{fill:url(#New_Gradient_Swatch_3-30);}.cls-51{fill:url(#New_Gradient_Swatch_3-31);}.cls-52{fill:url(#New_Gradient_Swatch_3-33);}.cls-53{fill:url(#New_Gradient_Swatch_3-32);}.cls-54{fill:url(#New_Gradient_Swatch_3-34);}.cls-55{fill:url(#New_Gradient_Swatch_3-23);}.cls-56{fill:url(#New_Gradient_Swatch_3-26);}.cls-57{fill:url(#New_Gradient_Swatch_3-29);}.cls-58{fill:url(#New_Gradient_Swatch_3-24);}.cls-59{fill:url(#New_Gradient_Swatch_3-25);}.cls-60{fill:url(#New_Gradient_Swatch_3-37);}.cls-61{fill:url(#New_Gradient_Swatch_3-36);}.cls-62{fill:url(#New_Gradient_Swatch_3-35);}.cls-63{fill:url(#New_Gradient_Swatch_3-38);}.cls-64{fill:url(#New_Gradient_Swatch_3-39);}.cls-65{fill:url(#New_Gradient_Swatch_3-41);}.cls-66{fill:url(#New_Gradient_Swatch_3-40);}.cls-67{fill:url(#New_Gradient_Swatch_3-18);}.cls-68{fill:url(#New_Gradient_Swatch_3-14);}.cls-69{fill:url(#New_Gradient_Swatch_3-17);}.cls-70{fill:url(#New_Gradient_Swatch_3-16);}.cls-71{fill:url(#New_Gradient_Swatch_3-19);}.cls-72{fill:url(#New_Gradient_Swatch_3-20);}.cls-73{fill:url(#New_Gradient_Swatch_3-13);}.cls-74{fill:url(#New_Gradient_Swatch_3-22);}.cls-75{fill:url(#New_Gradient_Swatch_3-15);}.cls-76{fill:url(#New_Gradient_Swatch_3-62);}.cls-77{fill:url(#New_Gradient_Swatch_3-63);}.cls-78{fill:url(#New_Gradient_Swatch_3-64);}.cls-79{fill:url(#New_Gradient_Swatch_3-69);}.cls-80{fill:url(#New_Gradient_Swatch_3-85);}.cls-81{fill:url(#New_Gradient_Swatch_3-89);}.cls-82{fill:url(#New_Gradient_Swatch_3-88);}.cls-83{fill:url(#New_Gradient_Swatch_3-81);}.cls-84{fill:url(#New_Gradient_Swatch_3-87);}.cls-85{fill:url(#New_Gradient_Swatch_3-82);}.cls-86{fill:url(#New_Gradient_Swatch_3-65);}.cls-87{fill:url(#New_Gradient_Swatch_3-66);}.cls-88{fill:url(#New_Gradient_Swatch_3-68);}.cls-89{fill:url(#New_Gradient_Swatch_3-67);}.cls-90{fill:url(#New_Gradient_Swatch_3-83);}.cls-91{fill:url(#New_Gradient_Swatch_3-84);}.cls-92{fill:url(#New_Gradient_Swatch_3-70);}.cls-93{fill:url(#New_Gradient_Swatch_3-97);}.cls-94{fill:url(#New_Gradient_Swatch_3-98);}.cls-95{fill:url(#New_Gradient_Swatch_3-92);}.cls-96{fill:url(#New_Gradient_Swatch_3-91);}.cls-97{fill:url(#New_Gradient_Swatch_3-90);}.cls-98{fill:url(#New_Gradient_Swatch_3-80);}.cls-99{fill:url(#New_Gradient_Swatch_3-86);}.cls-100{fill:url(#New_Gradient_Swatch_3-71);}.cls-101{fill:url(#New_Gradient_Swatch_3-76);}.cls-102{fill:url(#New_Gradient_Swatch_3-77);}.cls-103{fill:url(#New_Gradient_Swatch_3-72);}.cls-104{fill:url(#New_Gradient_Swatch_3-73);}.cls-105{fill:url(#New_Gradient_Swatch_3-78);}.cls-106{fill:url(#New_Gradient_Swatch_3-74);}.cls-107{fill:url(#New_Gradient_Swatch_3-54);}.cls-108{fill:url(#New_Gradient_Swatch_3-57);}.cls-109{fill:url(#New_Gradient_Swatch_3-56);}.cls-110{fill:url(#New_Gradient_Swatch_3-59);}.cls-111{fill:url(#New_Gradient_Swatch_3-79);}.cls-112{fill:url(#New_Gradient_Swatch_3-93);}.cls-113{fill:url(#New_Gradient_Swatch_3-96);}.cls-114{fill:url(#New_Gradient_Swatch_3-94);}.cls-115{fill:url(#New_Gradient_Swatch_3-95);}.cls-116{fill:url(#New_Gradient_Swatch_3-99);}.cls-117{fill:url(#New_Gradient_Swatch_3-75);}.cls-118{fill:url(#New_Gradient_Swatch_3-50);}.cls-119{fill:url(#New_Gradient_Swatch_3-51);}.cls-120{fill:url(#New_Gradient_Swatch_3-55);}.cls-121{fill:url(#New_Gradient_Swatch_3-52);}.cls-122{fill:url(#New_Gradient_Swatch_3-53);}.cls-123{fill:url(#New_Gradient_Swatch_3-58);}.cls-124{fill:url(#New_Gradient_Swatch_3-43);}.cls-125{fill:url(#New_Gradient_Swatch_3-47);}.cls-126{fill:url(#New_Gradient_Swatch_3-46);}.cls-127{fill:url(#New_Gradient_Swatch_3-49);}.cls-128{fill:url(#New_Gradient_Swatch_3-61);}.cls-129{fill:url(#New_Gradient_Swatch_3-48);}.cls-130{fill:url(#New_Gradient_Swatch_3-60);}.cls-131{fill:url(#New_Gradient_Swatch_3-42);}.cls-132{fill:url(#New_Gradient_Swatch_3-44);}.cls-133{fill:url(#New_Gradient_Swatch_3-45);}.cls-134{fill:url(#New_Gradient_Swatch_3-100);}.cls-135{fill:url(#New_Gradient_Swatch_3-105);}.cls-136{fill:url(#New_Gradient_Swatch_3-108);}.cls-137{fill:url(#New_Gradient_Swatch_3-106);}.cls-138{fill:url(#New_Gradient_Swatch_3-107);}.cls-139{fill:url(#New_Gradient_Swatch_3-109);}.cls-140{fill:url(#New_Gradient_Swatch_3-102);}.cls-141{fill:url(#New_Gradient_Swatch_3-103);}.cls-142{fill:url(#New_Gradient_Swatch_3-104);}.cls-143{fill:url(#New_Gradient_Swatch_3-101);}.cls-144{fill:url(#New_Gradient_Swatch_3-140);}.cls-145{fill:url(#New_Gradient_Swatch_3-120);}.cls-146{fill:url(#New_Gradient_Swatch_3-143);}.cls-147{fill:url(#New_Gradient_Swatch_3-145);}.cls-148{fill:url(#New_Gradient_Swatch_3-144);}.cls-149{fill:url(#New_Gradient_Swatch_3-146);}.cls-150{fill:url(#New_Gradient_Swatch_3-138);}.cls-151{fill:url(#New_Gradient_Swatch_3-137);}.cls-152{fill:url(#New_Gradient_Swatch_3-142);}.cls-153{fill:url(#New_Gradient_Swatch_3-141);}.cls-154{fill:url(#New_Gradient_Swatch_3-110);}.cls-155{fill:url(#New_Gradient_Swatch_3-139);}.cls-156{fill:url(#New_Gradient_Swatch_3-130);}.cls-157{fill:url(#New_Gradient_Swatch_3-132);}.cls-158{fill:url(#New_Gradient_Swatch_3-131);}.cls-159{fill:url(#New_Gradient_Swatch_3-133);}.cls-160{fill:url(#New_Gradient_Swatch_3-134);}.cls-161{fill:url(#New_Gradient_Swatch_3-136);}.cls-162{fill:url(#New_Gradient_Swatch_3-135);}.cls-163{fill:url(#New_Gradient_Swatch_3-128);}.cls-164{fill:url(#New_Gradient_Swatch_3-129);}.cls-165{fill:url(#New_Gradient_Swatch_3-124);}.cls-166{fill:url(#New_Gradient_Swatch_3-126);}.cls-167{fill:url(#New_Gradient_Swatch_3-127);}.cls-168{fill:url(#New_Gradient_Swatch_3-122);}.cls-169{fill:url(#New_Gradient_Swatch_3-123);}.cls-170{fill:url(#New_Gradient_Swatch_3-125);}.cls-171{fill:url(#New_Gradient_Swatch_3-117);}.cls-172{fill:url(#New_Gradient_Swatch_3-118);}.cls-173{fill:url(#New_Gradient_Swatch_3-119);}.cls-174{fill:url(#New_Gradient_Swatch_3-116);}.cls-175{fill:url(#New_Gradient_Swatch_3-115);}.cls-176{fill:url(#New_Gradient_Swatch_3-121);}.cls-177{fill:url(#New_Gradient_Swatch_3-111);}.cls-178{fill:url(#New_Gradient_Swatch_3-114);}.cls-179{fill:url(#New_Gradient_Swatch_3-113);}.cls-180{fill:url(#New_Gradient_Swatch_3-112);}.cls-182{fill:#808285;}.cls-183,.cls-197,.cls-201{fill:#fff;}.cls-183,.cls-198,.cls-199{opacity:.3;}.cls-184{fill:url(#radial-gradient-2);}.cls-185{fill:#ed1c24;}.cls-186{fill:url(#linear-gradient-19);opacity:.8;}.cls-187,.cls-204{fill:#be1e2d;}.cls-188{fill:url(#linear-gradient-4);}.cls-189{fill:url(#linear-gradient-2);}.cls-190{fill:url(#linear-gradient-3);}.cls-191{fill:url(#linear-gradient-8);}.cls-192{fill:url(#linear-gradient-9);}.cls-193{fill:url(#linear-gradient-7);}.cls-194{fill:url(#linear-gradient-5);}.cls-195{fill:url(#linear-gradient-6);}.cls-196,.cls-202{fill:#939598;}.cls-225{isolation:isolate;}.cls-197{opacity:.4;}.cls-198{fill:url(#linear-gradient-23);}.cls-199{fill:url(#linear-gradient-21);}.cls-200{fill:#d1d3d4;}.cls-226{mask:url(#mask-3);}.cls-227{mask:url(#mask-2);}.cls-228{mask:url(#mask-5);}.cls-229{mask:url(#mask-4);}.cls-230{mask:url(#mask-1);}.cls-231{mask:url(#mask-7);}.cls-232{mask:url(#mask-6);}.cls-233{mask:url(#mask-8);}.cls-234{mask:url(#mask-9);}.cls-203{fill:#231f20;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 80.64,
    y1: 127.18,
    x2: 111.17,
    y2: 127.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 95.9,
    y1: 162.16,
    x2: 95.9,
    y2: 92.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 95.9,
    y1: 96.38,
    x2: 95.9,
    y2: 158.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 95.97,
    y1: 93.6,
    x2: 95.97,
    y2: 97.69,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 307.96,
    y1: 276.25,
    x2: 307.96,
    y2: 280.34,
    gradientTransform: "translate(-214.76 -182.52)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: 504.41,
    y1: 475.51,
    x2: 504.41,
    y2: 479.6,
    gradientTransform: "translate(-413.87 -381.47)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-5",
    x1: 681.82,
    y1: 692.32,
    x2: 681.82,
    y2: 696.4,
    gradientTransform: "translate(-594 -597.63)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-6",
    x1: 839.5,
    y1: 923.01,
    x2: 839.5,
    y2: 927.1,
    gradientTransform: "translate(-754.28 -827.56)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-7",
    x1: 976.81,
    y1: 1167.08,
    x2: 976.81,
    y2: 1171.16,
    gradientTransform: "translate(-894.08 -1070.6)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-8",
    x1: 1092.14,
    y1: 1422.33,
    x2: 1092.14,
    y2: 1426.42,
    gradientTransform: "translate(-1011.96 -1324.47)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-9",
    x1: 1184.21,
    y1: 1685.55,
    x2: 1184.21,
    y2: 1689.64,
    gradientTransform: "translate(-1106.34 -1586.42)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-10",
    x1: 1254.16,
    y1: 1957.74,
    x2: 1254.16,
    y2: 1961.83,
    gradientTransform: "translate(-1178.48 -1856.73)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-11",
    x1: 1299.78,
    y1: 2233.28,
    x2: 1299.78,
    y2: 2237.37,
    gradientTransform: "translate(-1226.12 -2130.47)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-12",
    x1: 1321.56,
    y1: 2511.99,
    x2: 1321.56,
    y2: 2516.08,
    gradientTransform: "translate(-1249.4 -2407.29)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-13",
    x1: 1317.16,
    y1: 2791.68,
    x2: 1317.16,
    y2: 2795.76,
    gradientTransform: "translate(-1246.89 -2684.93)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-14",
    x1: 1290.7,
    y1: 3070.54,
    x2: 1290.7,
    y2: 3074.62,
    gradientTransform: "translate(-1221.9 -2961.22)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-15",
    x1: 1238.73,
    y1: 3345.79,
    x2: 1238.73,
    y2: 3349.87,
    gradientTransform: "translate(-1171.29 -3234.01)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-16",
    x1: 1163.05,
    y1: 3615.21,
    x2: 1163.05,
    y2: 3619.3,
    gradientTransform: "translate(-1096.84 -3500.89)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-17",
    x1: 1064.84,
    y1: 3877.25,
    x2: 1064.84,
    y2: 3881.33,
    gradientTransform: "translate(-999.27 -3760.24)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-18",
    x1: 943.26,
    y1: 4129.77,
    x2: 943.26,
    y2: 4133.86,
    gradientTransform: "translate(-878.63 -4010.05)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-19",
    x1: 801.27,
    y1: 4369.3,
    x2: 801.27,
    y2: 4373.38,
    gradientTransform: "translate(-736.48 -4247.06)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-20",
    x1: 637.89,
    y1: 4597.28,
    x2: 637.89,
    y2: 4601.36,
    gradientTransform: "translate(-573.52 -4472.2)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-21",
    x1: 455.09,
    y1: 4809.98,
    x2: 455.09,
    y2: 4814.07,
    gradientTransform: "translate(-390.7 -4682.19)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-22",
    x1: 256.24,
    y1: 5004.95,
    x2: 256.24,
    y2: 5009.04,
    gradientTransform: "translate(-191.07 -4874.33)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-23",
    x1: 39.66,
    y1: 5182.93,
    x2: 39.66,
    y2: 5187.02,
    gradientTransform: "translate(25.65 -5049.53)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-24",
    x1: -191.52,
    y1: 5340.45,
    x2: -191.52,
    y2: 5344.53,
    gradientTransform: "translate(257.89 -5204.58)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-25",
    x1: -435.35,
    y1: 5477.9,
    x2: -435.35,
    y2: 5481.98,
    gradientTransform: "translate(502.9 -5339.38)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-26",
    x1: -690.48,
    y1: 5593.65,
    x2: -690.48,
    y2: 5597.74,
    gradientTransform: "translate(758.75 -5452.71)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-27",
    x1: -954.93,
    y1: 5685.38,
    x2: -954.93,
    y2: 5689.47,
    gradientTransform: "translate(1024.8 -5542.54)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-28",
    x1: -1225.82,
    y1: 5756.09,
    x2: -1225.82,
    y2: 5760.18,
    gradientTransform: "translate(1296.92 -5610.7)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-29",
    x1: -1501.63,
    y1: 5801.08,
    x2: -1501.63,
    y2: 5805.17,
    gradientTransform: "translate(1575.17 -5653.63)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-30",
    x1: -1780.08,
    y1: 5822.23,
    x2: -1780.08,
    y2: 5826.32,
    gradientTransform: "translate(1855.7 -5672.79)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-31",
    x1: -2061.05,
    y1: 5818.6,
    x2: -2061.05,
    y2: 5822.68,
    gradientTransform: "translate(2138.7 -5668.04)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-32",
    x1: -2338.69,
    y1: 5791.79,
    x2: -2338.69,
    y2: 5795.88,
    gradientTransform: "translate(2418.56 -5639.3)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-33",
    x1: -2614.05,
    y1: 5740.25,
    x2: -2614.05,
    y2: 5744.33,
    gradientTransform: "translate(2696.39 -5586.52)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-34",
    x1: -2883.72,
    y1: 5664.7,
    x2: -2883.72,
    y2: 5668.79,
    gradientTransform: "translate(2968.83 -5509.92)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-35",
    x1: -3145.27,
    y1: 5566.33,
    x2: -3145.27,
    y2: 5570.42,
    gradientTransform: "translate(3232.59 -5410.72)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-36",
    x1: -3398.02,
    y1: 5445.33,
    x2: -3398.02,
    y2: 5449.41,
    gradientTransform: "translate(3487.96 -5289.27)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-37",
    x1: -3637.96,
    y1: 5301.85,
    x2: -3637.96,
    y2: 5305.94,
    gradientTransform: "translate(3731.45 -5145.09)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-38",
    x1: -3865.79,
    y1: 5139.19,
    x2: -3865.79,
    y2: 5143.28,
    gradientTransform: "translate(3961.62 -4982.51)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-39",
    x1: -4078.64,
    y1: 4957.11,
    x2: -4078.64,
    y2: 4961.2,
    gradientTransform: "translate(4176.94 -4800.85)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-40",
    x1: -4273.2,
    y1: 4756.78,
    x2: -4273.2,
    y2: 4760.87,
    gradientTransform: "translate(4374.76 -4600.21)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-41",
    x1: -4450.95,
    y1: 4540.78,
    x2: -4450.95,
    y2: 4544.86,
    gradientTransform: "translate(4554.78 -4385.04)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-42",
    x1: -4608.96,
    y1: 4309.43,
    x2: -4608.96,
    y2: 4313.52,
    gradientTransform: "translate(4715.76 -4154.43)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-43",
    x1: -4746.16,
    y1: 4065.74,
    x2: -4746.16,
    y2: 4069.83,
    gradientTransform: "translate(4855.47 -3911.69)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-44",
    x1: -4861.8,
    y1: 3811.04,
    x2: -4861.8,
    y2: 3815.12,
    gradientTransform: "translate(4973.38 -3658.37)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-45",
    x1: -4954.76,
    y1: 3546.24,
    x2: -4954.76,
    y2: 3550.33,
    gradientTransform: "translate(5069.09 -3395.22)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-46",
    x1: -5024.17,
    y1: 3276.11,
    x2: -5024.17,
    y2: 3280.2,
    gradientTransform: "translate(5140 -3126.93)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-47",
    x1: -5069.44,
    y1: 2999.67,
    x2: -5069.44,
    y2: 3003.76,
    gradientTransform: "translate(5187.66 -2851.95)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-48",
    x1: -5090.32,
    y1: 2720.6,
    x2: -5090.32,
    y2: 2724.69,
    gradientTransform: "translate(5210.45 -2574.59)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-49",
    x1: -5087.98,
    y1: 2440.39,
    x2: -5087.98,
    y2: 2444.48,
    gradientTransform: "translate(5210.04 -2297.03)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-50",
    x1: -5059.94,
    y1: 2162.41,
    x2: -5059.94,
    y2: 2166.5,
    gradientTransform: "translate(5183.07 -2021.24)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-51",
    x1: -5008.51,
    y1: 1887.47,
    x2: -5008.51,
    y2: 1891.56,
    gradientTransform: "translate(5132.9 -1748.91)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-52",
    x1: -4933.21,
    y1: 1617.94,
    x2: -4933.21,
    y2: 1622.02,
    gradientTransform: "translate(5058.78 -1481.8)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-53",
    x1: -4834.35,
    y1: 1356.23,
    x2: -4834.35,
    y2: 1360.32,
    gradientTransform: "translate(4960.59 -1222.72)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-54",
    x1: -4713.57,
    y1: 1104.05,
    x2: -4713.57,
    y2: 1108.14,
    gradientTransform: "translate(4840.39 -973.61)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-55",
    x1: -4570.52,
    y1: 862.63,
    x2: -4570.52,
    y2: 866.72,
    gradientTransform: "translate(4697.93 -734.38)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-56",
    x1: -4407.7,
    y1: 635.52,
    x2: -4407.7,
    y2: 639.61,
    gradientTransform: "translate(4535.15 -510.31)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-57",
    x1: -4225.77,
    y1: 423.38,
    x2: -4225.77,
    y2: 427.47,
    gradientTransform: "translate(4353.11 -301.22)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-58",
    x1: -4025.03,
    y1: 227.35,
    x2: -4025.03,
    y2: 231.43,
    gradientTransform: "translate(4151.96 -107.38)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-59",
    x1: -3808.8,
    y1: 50.16,
    x2: -3808.8,
    y2: 54.25,
    gradientTransform: "translate(3935.07 67)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-60",
    x1: -3577.94,
    y1: -108.01,
    x2: -3577.94,
    y2: -103.92,
    gradientTransform: "translate(3703.5 222.51)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-61",
    x1: -3334.01,
    y1: -245.08,
    x2: -3334.01,
    y2: -240.99,
    gradientTransform: "translate(3458.47 357.03)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-62",
    x1: -3079.18,
    y1: -360.29,
    x2: -3079.18,
    y2: -356.2,
    gradientTransform: "translate(3202.38 469.62)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-63",
    x1: -2815.62,
    y1: -453.59,
    x2: -2815.62,
    y2: -449.5,
    gradientTransform: "translate(2937.54 560.74)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-64",
    x1: -2544.19,
    y1: -522.24,
    x2: -2544.19,
    y2: -518.16,
    gradientTransform: "translate(2664.26 627.01)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-65",
    x1: -2268.02,
    y1: -568.13,
    x2: -2268.02,
    y2: -564.05,
    gradientTransform: "translate(2386.26 671.02)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-66",
    x1: -1988.69,
    y1: -589.64,
    x2: -1988.69,
    y2: -585.55,
    gradientTransform: "translate(2104.87 690.61)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-67",
    x1: -1709.77,
    y1: -586.53,
    x2: -1709.77,
    y2: -582.45,
    gradientTransform: "translate(1823.9 685.92)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-68",
    x1: -1430.56,
    y1: -558.85,
    x2: -1430.56,
    y2: -554.76,
    gradientTransform: "translate(1542.26 656.7)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-69",
    x1: -1155.74,
    y1: -506.99,
    x2: -1155.74,
    y2: -502.91,
    gradientTransform: "translate(1265.05 603.49)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-70",
    x1: -886.45,
    y1: -431.56,
    x2: -886.45,
    y2: -427.47,
    gradientTransform: "translate(993.21 527.06)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-71",
    x1: -624.25,
    y1: -332.86,
    x2: -624.25,
    y2: -328.77,
    gradientTransform: "translate(728.37 427.52)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-72",
    x1: -372.29,
    y1: -211.51,
    x2: -372.29,
    y2: -207.42,
    gradientTransform: "translate(473.75 305.58)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-73",
    x1: -131.29,
    y1: -69.93,
    x2: -131.29,
    y2: -65.84,
    gradientTransform: "translate(230.01 163.66)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 95.9,
    y1: 102.28,
    x2: 95.9,
    y2: 152.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 505.34,
    cy: -369.45,
    fx: 505.34,
    fy: -369.45,
    r: 27.16,
    gradientTransform: "translate(-324.89 434.83) scale(.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 95.9,
    y1: 132.86,
    x2: 95.9,
    y2: 121.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 360.52,
    x2: 391.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 375.79,
    x2: 375.79,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-74",
    x1: 375.79,
    x2: 375.79,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-75",
    x1: 375.86,
    y1: 93.6,
    x2: 375.86,
    y2: 97.69,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-76",
    x1: 586.77,
    y1: 300.66,
    x2: 586.77,
    y2: 304.74,
    gradientTransform: "translate(-213.69 -206.9)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-77",
    x1: 780.05,
    y1: 524.1,
    x2: 780.05,
    y2: 528.19,
    gradientTransform: "translate(-409.62 -430.08)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-78",
    x1: 952.18,
    y1: 764.75,
    x2: 952.18,
    y2: 768.84,
    gradientTransform: "translate(-584.45 -670.08)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-79",
    x1: 1102.5,
    y1: 1018.73,
    x2: 1102.5,
    y2: 1022.82,
    gradientTransform: "translate(-737.4 -923.3)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-80",
    x1: 1230.48,
    y1: 1285.36,
    x2: 1230.48,
    y2: 1289.45,
    gradientTransform: "translate(-867.85 -1188.9)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-81",
    x1: 1334.53,
    y1: 1562.28,
    x2: 1334.53,
    y2: 1566.37,
    gradientTransform: "translate(-974.43 -1464.45)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-82",
    x1: 1413.47,
    y1: 1846.08,
    x2: 1413.47,
    y2: 1850.17,
    gradientTransform: "translate(-1055.72 -1746.96)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-83",
    x1: 1468.57,
    y1: 2137.66,
    x2: 1468.57,
    y2: 2141.75,
    gradientTransform: "translate(-1112.92 -2036.69)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-84",
    x1: 1497.69,
    y1: 2431.19,
    x2: 1497.69,
    y2: 2435.28,
    gradientTransform: "translate(-1144.14 -2328.37)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-85",
    x1: 1501.48,
    y1: 2726.4,
    x2: 1501.48,
    y2: 2730.48,
    gradientTransform: "translate(-1149.4 -2621.71)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-86",
    x1: 1477.68,
    y1: 3020.93,
    x2: 1477.68,
    y2: 3025.02,
    gradientTransform: "translate(-1127.65 -2914.15)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-87",
    x1: 1430.65,
    y1: 3312.93,
    x2: 1430.65,
    y2: 3317.02,
    gradientTransform: "translate(-1082.1 -3203.54)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-88",
    x1: 1357.01,
    y1: 3599.46,
    x2: 1357.01,
    y2: 3603.54,
    gradientTransform: "translate(-1009.85 -3487.61)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-89",
    x1: 1258.77,
    y1: 3878.22,
    x2: 1258.77,
    y2: 3882.31,
    gradientTransform: "translate(-912.68 -3763.9)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-90",
    x1: 1137.28,
    y1: 4147.6,
    x2: 1137.28,
    y2: 4151.69,
    gradientTransform: "translate(-791.81 -4030.59)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-91",
    x1: 991.85,
    y1: 4405.41,
    x2: 991.85,
    y2: 4409.5,
    gradientTransform: "translate(-647.11 -4285.74)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-92",
    x1: 825.67,
    y1: 4648.11,
    x2: 825.67,
    y2: 4652.2,
    gradientTransform: "translate(-480.98 -4525.88)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-93",
    x1: 637.89,
    y1: 4877.16,
    x2: 637.89,
    y2: 4881.25,
    gradientTransform: "translate(-293.64 -4752.09)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-94",
    x1: 430.68,
    y1: 5088.8,
    x2: 430.68,
    y2: 5092.88,
    gradientTransform: "translate(-86.41 -4961.01)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-95",
    x1: 207.65,
    y1: 5280.59,
    x2: 207.65,
    y2: 5284.68,
    gradientTransform: "translate(137.14 -5149.96)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-96",
    x1: -32.77,
    y1: 5453.29,
    x2: -32.77,
    y2: 5457.37,
    gradientTransform: "translate(378.25 -5319.88)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-97",
    x1: -287.24,
    y1: 5603.46,
    x2: -287.24,
    y2: 5607.54,
    gradientTransform: "translate(633.21 -5467.6)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-98",
    x1: -553.63,
    y1: 5731.57,
    x2: -553.63,
    y2: 5735.65,
    gradientTransform: "translate(900.52 -5593.09)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-99",
    x1: -830.43,
    y1: 5836.04,
    x2: -830.43,
    y2: 5840.13,
    gradientTransform: "translate(1178.57 -5695.1)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-100",
    x1: -1115.46,
    y1: 5914.64,
    x2: -1115.46,
    y2: 5918.73,
    gradientTransform: "translate(1465.21 -5771.82)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-101",
    x1: -1405.74,
    y1: 5970.5,
    x2: -1405.74,
    y2: 5974.58,
    gradientTransform: "translate(1756.95 -5825.06)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-102",
    x1: -1699.54,
    y1: 5999,
    x2: -1699.54,
    y2: 6003.08,
    gradientTransform: "translate(2052.74 -5851.6)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-103",
    x1: -1994.48,
    y1: 6002.15,
    x2: -1994.48,
    y2: 6006.24,
    gradientTransform: "translate(2349.78 -5852.77)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-104",
    x1: -2290.31,
    y1: 5979.12,
    x2: -2290.31,
    y2: 5983.21,
    gradientTransform: "translate(2647.85 -5828.58)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-105",
    x1: -2581.08,
    y1: 5931.74,
    x2: -2581.08,
    y2: 5935.83,
    gradientTransform: "translate(2940.99 -5779.18)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-106",
    x1: -2867.72,
    y1: 5858.53,
    x2: -2867.72,
    y2: 5862.62,
    gradientTransform: "translate(3230.07 -5704.74)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-107",
    x1: -3146.73,
    y1: 5760.42,
    x2: -3146.73,
    y2: 5764.51,
    gradientTransform: "translate(3511.72 -5605.63)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-108",
    x1: -3415.62,
    y1: 5638.77,
    x2: -3415.62,
    y2: 5642.86,
    gradientTransform: "translate(3782.75 -5483.21)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-109",
    x1: -3673.66,
    y1: 5493.92,
    x2: -3673.66,
    y2: 5498,
    gradientTransform: "translate(4043.48 -5337.88)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-110",
    x1: -3916.77,
    y1: 5326.26,
    x2: -3916.77,
    y2: 5330.35,
    gradientTransform: "translate(4290.13 -5169.49)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-111",
    x1: -4145.67,
    y1: 5139.19,
    x2: -4145.67,
    y2: 5143.28,
    gradientTransform: "translate(4521.39 -4982.51)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-112",
    x1: -4357.46,
    y1: 4932.71,
    x2: -4357.46,
    y2: 4936.79,
    gradientTransform: "translate(4735.64 -4776.47)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-113",
    x1: -4548.84,
    y1: 4708.19,
    x2: -4548.84,
    y2: 4712.28,
    gradientTransform: "translate(4930.28 -4551.6)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-114",
    x1: -4721.31,
    y1: 4468.34,
    x2: -4721.31,
    y2: 4472.42,
    gradientTransform: "translate(5104.96 -4312.67)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-115",
    x1: -4871.97,
    y1: 4213.71,
    x2: -4871.97,
    y2: 4217.79,
    gradientTransform: "translate(5258.65 -4058.7)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-116",
    x1: -4999.83,
    y1: 3947.46,
    x2: -4999.83,
    y2: 3951.54,
    gradientTransform: "translate(5389.01 -3793.39)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-117",
    x1: -5104.19,
    y1: 3671.09,
    x2: -5104.19,
    y2: 3675.17,
    gradientTransform: "translate(5495.74 -3518.28)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-118",
    x1: -5184.02,
    y1: 3385.71,
    x2: -5184.02,
    y2: 3389.8,
    gradientTransform: "translate(5578.35 -3234.52)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-119",
    x1: -5238.58,
    y1: 3096.19,
    x2: -5238.58,
    y2: 3100.28,
    gradientTransform: "translate(5634.4 -2946.84)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-120",
    x1: -5267.35,
    y1: 2801.76,
    x2: -5267.35,
    y2: 2805.85,
    gradientTransform: "translate(5665.34 -2654.24)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-121",
    x1: -5270.24,
    y1: 2506.2,
    x2: -5270.24,
    y2: 2510.29,
    gradientTransform: "translate(5670.23 -2360.18)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-122",
    x1: -5248.5,
    y1: 2211.13,
    x2: -5248.5,
    y2: 2215.22,
    gradientTransform: "translate(5650.35 -2067.99)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-123",
    x1: -5199.89,
    y1: 1920.02,
    x2: -5199.89,
    y2: 1924.1,
    gradientTransform: "translate(5602.9 -1778.85)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-124",
    x1: -5126.8,
    y1: 1633.8,
    x2: -5126.8,
    y2: 1637.89,
    gradientTransform: "translate(5531.06 -1495.25)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-125",
    x1: -5028.93,
    y1: 1354.93,
    x2: -5028.93,
    y2: 1359.02,
    gradientTransform: "translate(5434.38 -1218.79)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-126",
    x1: -4906.79,
    y1: 1085.88,
    x2: -4906.79,
    y2: 1089.96,
    gradientTransform: "translate(5312.96 -952.11)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-127",
    x1: -4762.16,
    y1: 828.41,
    x2: -4762.16,
    y2: 832.5,
    gradientTransform: "translate(5168.88 -697.98)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-128",
    x1: -4594.92,
    y1: 583.82,
    x2: -4594.92,
    y2: 587.9,
    gradientTransform: "translate(5002.17 -455.81)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-129",
    x1: -4407.7,
    y1: 355.63,
    x2: -4407.7,
    y2: 359.72,
    gradientTransform: "translate(4815.03 -230.42)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-130",
    x1: -4201.37,
    y1: 144.57,
    x2: -4201.37,
    y2: 148.65,
    gradientTransform: "translate(4608.61 -22.4)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-131",
    x1: -3976.44,
    y1: -48.29,
    x2: -3976.44,
    y2: -44.21,
    gradientTransform: "translate(4383.24 168.25)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-132",
    x1: -3736.36,
    y1: -220.19,
    x2: -3736.36,
    y2: -216.11,
    gradientTransform: "translate(4142.51 337.35)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-133",
    x1: -3482.22,
    y1: -371.01,
    x2: -3482.22,
    y2: -366.93,
    gradientTransform: "translate(3887.68 485.34)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-134",
    x1: -3215.73,
    y1: -498.75,
    x2: -3215.73,
    y2: -494.66,
    gradientTransform: "translate(3620.07 610.69)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-135",
    x1: -2939.24,
    y1: -602.68,
    x2: -2939.24,
    y2: -598.59,
    gradientTransform: "translate(3342.32 712.01)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-136",
    x1: -2655.09,
    y1: -682.85,
    x2: -2655.09,
    y2: -678.76,
    gradientTransform: "translate(3056.92 789.89)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-137",
    x1: -2364.27,
    y1: -736.65,
    x2: -2364.27,
    y2: -732.56,
    gradientTransform: "translate(2764.24 841.41)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-138",
    x1: -2070.11,
    y1: -766.04,
    x2: -2070.11,
    y2: -761.96,
    gradientTransform: "translate(2468.26 868.85)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-139",
    x1: -1774.28,
    y1: -769.56,
    x2: -1774.28,
    y2: -765.47,
    gradientTransform: "translate(2170.36 870.53)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-140",
    x1: -1480.51,
    y1: -747.06,
    x2: -1480.51,
    y2: -742.97,
    gradientTransform: "translate(1874.49 846.5)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-141",
    x1: -1188.17,
    y1: -698.79,
    x2: -1188.17,
    y2: -694.71,
    gradientTransform: "translate(1579.74 796.68)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-142",
    x1: -902.07,
    y1: -625.27,
    x2: -902.07,
    y2: -621.19,
    gradientTransform: "translate(1291.28 721.79)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-143",
    x1: -623.44,
    y1: -527.28,
    x2: -623.44,
    y2: -523.19,
    gradientTransform: "translate(1010.1 622.78)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-144",
    x1: -353.89,
    y1: -405.29,
    x2: -353.89,
    y2: -401.21,
    gradientTransform: "translate(737.91 499.97)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-145",
    x1: -96.65,
    y1: -260.1,
    x2: -96.65,
    y2: -256.01,
    gradientTransform: "translate(478 354.18)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-146",
    x1: 147.52,
    y1: -94.33,
    x2: 147.52,
    y2: -90.25,
    gradientTransform: "translate(231.08 188.06)",
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 375.79,
    y1: 102.28,
    x2: 375.79,
    y2: 152.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 841.46,
    fx: 841.46,
    r: 27.16,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 375.79,
    y1: 132.86,
    x2: 375.79,
    y2: 121.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 233.12,
    y1: 142.08,
    x2: 233.12,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 269.25,
    y1: 118.71,
    x2: 266.1,
    y2: 78.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#d7d8d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 95.9,
    y1: 76.44,
    x2: 95.9,
    y2: 146.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#dfe1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 375.72,
    x2: 375.72,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 175.11,
    y1: 52.13,
    x2: 175.11,
    y2: 39.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#eaeaeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 416.79,
    y: 85.51,
    width: 46.03,
    height: 7.26,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 416.79,
    y: -10792.48,
    width: 46.03,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 416.79,
    y: -10792.48,
    width: 46.03,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 439.8,
    y1: 92.77,
    x2: 439.8,
    y2: 85.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 416.79,
    y: 85.51,
    width: 46.03,
    height: 7.26,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-220"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-230"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M461.56,89.82c-1.47-.88-2.19-2.59-2.27-4.32-1.77,1.07-3.78,1.86-5.9,1.86h-36.51c-1.82,2.69,23.82,6.15,40.45,5.26,2.15-.12,3.96-.69,5.48-1.48-.38-.57-.79-1.04-1.26-1.32Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 439.8,
    y1: 92.77,
    x2: 439.8,
    y2: 85.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 395.86,
    y: 30.8,
    width: 60.77,
    height: 26.24,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 395.86,
    y: -10792.48,
    width: 60.77,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 395.86,
    y: -10792.48,
    width: 60.77,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 426.24,
    y1: 57.04,
    x2: 426.24,
    y2: 30.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 395.86,
    y: 30.8,
    width: 60.77,
    height: 26.24,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-216"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-226"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M456.62,57.04c-1.13-2.8-2.65-5.07-4.69-6.34-1.1-.69-2.18-1.36-3.26-2.03-13.45,0-26.68-3.46-38.42-10.03l-13.97-7.83h-.42l32.57,18.02c8.81,4.87,18.47,7.64,28.19,8.22Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 426.24,
    y1: 57.04,
    x2: 426.24,
    y2: 30.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 258.5,
    y1: 53.99,
    x2: 258.5,
    y2: 11.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#276f67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2a6862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#345754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 165.93,
    y1: 49.3,
    x2: 165.93,
    y2: 8.05,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 126.52,
    y: 41.37,
    width: 273.24,
    height: 23.42,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 126.52,
    y: -10792.48,
    width: 273.24,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 126.52,
    y: -10792.48,
    width: 273.24,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 212.8,
    y1: 100.52,
    x2: 213.18,
    y2: 107.02,
    gradientTransform: "translate(31.23 -39.99) rotate(-1.28) scale(1.08 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 126.52,
    y: 41.37,
    width: 273.24,
    height: 23.42,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-217"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-228"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M126.58,63.43s103.45-4.75,144.02-7.39c40.87-2.66,129.16-14.68,129.16-14.68,0,0-30.56,7.73-49.26,10.31-64.98,8.96-132.35,12.05-155.82,12.45-23.47.4-70.1,1.57-68.1-.69Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 212.8,
    y1: 100.52,
    x2: 213.18,
    y2: 107.02,
    gradientTransform: "translate(31.23 -39.99) rotate(-1.28) scale(1.08 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 229.79,
    y: 65.91,
    width: 22.78,
    height: 6.52,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 229.79,
    y: -10792.48,
    width: 22.78,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 229.79,
    y: -10792.48,
    width: 22.78,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 386.69,
    y1: 138.02,
    x2: 386.69,
    y2: 132.01,
    gradientTransform: "translate(-149.89 -52.86) rotate(-1.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#101010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 229.79,
    y: 65.91,
    width: 22.78,
    height: 6.52,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-215"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-231"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M252.56,70.02c-.22-2.62-4.01-4.44-8.47-4.06s-14.51,3.35-14.29,5.96c.01.17.08.34.18.5l22.58-1.89c.02-.17.02-.35,0-.52Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 386.69,
    y1: 138.02,
    x2: 386.69,
    y2: 132.01,
    gradientTransform: "translate(-149.89 -52.86) rotate(-1.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#d5d6d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e1e2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 337.37,
    y: 57.63,
    width: 22.78,
    height: 6.52,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 337.37,
    y: -10792.48,
    width: 22.78,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 337.37,
    y: -10792.48,
    width: 22.78,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 494.49,
    y1: 133.37,
    x2: 494.49,
    y2: 127.36,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 337.37,
    y: 57.63,
    width: 22.78,
    height: 6.52,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-214"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-234"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M360.14,61.74c-.22-2.62-4.01-4.44-8.47-4.06-4.46.37-14.51,3.35-14.29,5.96.01.17.08.34.18.51l22.58-1.89c.02-.17.02-.35,0-.52Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 494.49,
    y1: 133.37,
    x2: 494.49,
    y2: 127.36,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 441.88,
    y1: 81.51,
    x2: 441.88,
    y2: 60.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed1c24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 27.01,
    y1: 99.11,
    x2: 27.01,
    y2: 79.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -7201.04,
    y1: 83.86,
    x2: -7201.04,
    y2: 98.44,
    gradientTransform: "translate(-7174.94) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -7209.46,
    y1: 82.58,
    x2: -7209.46,
    y2: 93.86,
    gradientTransform: "translate(-7174.94) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-11",
    x: 41.72,
    y: 76.01,
    width: 108.38,
    height: 68.28,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-12",
    x: 41.72,
    y: -10792.48,
    width: 108.38,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 41.72,
    y: -10792.48,
    width: 108.38,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 95.9,
    y1: 76.44,
    x2: 95.9,
    y2: 146.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 41.72,
    y: 76.01,
    width: 108.38,
    height: 68.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-224"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-211"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M150.06,142.08c0-.44.03-.87.03-1.31,0-35.77-24.26-64.76-54.19-64.76s-54.19,28.99-54.19,64.76c0,.14,0,.27,0,.41l12.09,3.12c-.07-1.43-.12-5.09-.12-6.55,0-33.68,18.9-52.31,42.21-52.31s42.21,18.63,42.21,52.31c0,1.46-.05,5.12-.12,6.55l12.07-2.22Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 95.9,
    y1: 76.44,
    x2: 95.9,
    y2: 146.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-13",
    x: 321.53,
    y: 76.01,
    width: 108.36,
    height: 68.28,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-14",
    x: 321.53,
    y: -10792.48,
    width: 108.36,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 321.53,
    y: -10792.48,
    width: 108.36,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 375.72,
    x2: 375.72,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    x: 321.53,
    y: 76.01,
    width: 108.36,
    height: 68.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-223"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-209"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M429.9,140.25c-.23-35.53-24.39-64.24-54.18-64.24s-54.19,28.99-54.19,64.76c0,.44.02.87.03,1.31l12.14,2.22c-.07-1.43-.12-5.09-.12-6.55,0-33.68,18.9-52.31,42.21-52.31s42.21,18.63,42.21,52.31c0,1.46-.05,5.12-.12,6.55l12.02-4.04Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 375.72,
    x2: 375.72,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-15",
    x: 139.87,
    y: 72.57,
    width: 235.85,
    height: 49.2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-16",
    x: 139.87,
    y: -10792.48,
    width: 235.85,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: 139.87,
    y: -10792.48,
    width: 235.85,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 260.44,
    y1: 118.85,
    x2: 257.33,
    y2: 79.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: 139.87,
    y: 72.57,
    width: 235.85,
    height: 49.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-222"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M147.95,114.77c.66,2,2.28,3.54,4.31,4.09,9.53,2.56,23.05,3.95,42.02,1.98l123.69-5.65c3.3-.15,6.22-2.2,7.48-5.26h0c9.45-23.04,28.71-37.36,50.27-37.36-23.55-.37-195.15,6.21-235.85,25.39,3.33,5.04,6.07,10.69,8.08,16.8Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 260.44,
    y1: 118.85,
    x2: 257.33,
    y2: 79.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-17",
    x: 166.89,
    y: 38.71,
    width: 17.6,
    height: 10.35,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-18",
    x: 166.89,
    y: -10792.48,
    width: 17.6,
    height: 32766,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    x: 166.89,
    y: -10792.48,
    width: 17.6,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 175.69,
    y1: 47.28,
    x2: 175.69,
    y2: 39.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0a0a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    x: 166.89,
    y: 38.71,
    width: 17.6,
    height: 10.35,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-221"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M182.14,38.71h-.59c-7.02,0-12.91,4.39-14.65,10.35,0,0,8.89-1.1,14.36-2.89,2.39-.78,3.83-3.37,3.02-5.76-.33-.96-.96-1.7-2.13-1.7Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 175.69,
    y1: 47.28,
    x2: 175.69,
    y2: 39.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 417.57,
    y1: 47.42,
    x2: 417.57,
    y2: 15.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#276f67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#315c58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3c4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M194.62,70.54h0c-1.22.59-2.7.08-3.29-1.13l-11.85-24.29c-.59-1.22-.08-2.7,1.13-3.29h0c1.22-.59,2.7-.08,3.29,1.13l11.85,24.29c.59,1.22.08,2.7-1.13,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M259.53,44.68c1.16-1.23,1.85-2.91,1.76-4.73l-.63-12.22c-.18-3.53-3.22-6.27-6.76-6.09h-.21c-3.53.19-6.27,3.23-6.09,6.77l.63,12.22c.09,1.83.97,3.44,2.27,4.55-2.68,1.43-4.75,3.98-5.45,7.16l-7.8,35.53c-1.27,5.77,2.42,11.53,8.19,12.79,5.77,1.27,11.53-2.42,12.79-8.19l7.8-35.53c1.14-5.18-1.73-10.35-6.5-12.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M365.65,44.68c1.16-1.23,1.85-2.91,1.76-4.73l-.63-12.22c-.18-3.53-3.22-6.27-6.76-6.09h-.21c-3.53.19-6.27,3.23-6.09,6.77l.63,12.22c.1,1.83.97,3.44,2.27,4.55-2.68,1.43-4.75,3.98-5.45,7.16l-4.05,18.87c-1.27,5.77,2.42,11.53,8.19,12.79,5.77,1.27,11.53-2.42,12.79-8.19l4.05-18.87c1.14-5.18-1.73-10.35-6.5-12.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M446.98,79.95H59.03C-2.39,77.12,2.06,127.89,2.06,127.89c-1.18,2.37-.11,7.93,40.03,15.12h13.32c0-2.83,13.52-5.2,31.63-5.8,2.36,2.09,5.46,3.37,8.86,3.37s6.51-1.28,8.87-3.38c18.36.58,32.12,2.96,32.12,5.82h7.2c.67.45,1.47.71,2.34.71h179.03c.87,0,1.67-.26,2.34-.71h7.3c0-2.83,13.52-5.2,31.63-5.8,2.36,2.09,5.46,3.37,8.86,3.37s6.52-1.29,8.88-3.39c18.35.58,32.1,2.96,32.1,5.82h2.21c8.7.46,24.8-6.08,34.93-10.68,6.61-3,10.97-9.4,11.43-16.65.96-14.95-18.19-35.74-18.19-35.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M446.56,52.94h0c-28.43,0-55.36-12.8-73.31-34.86l-2.79-3.42c-1-1.23-.13-3.06,1.46-3.06h1.53c3.3-6.25,95.45,43.99,73.1,41.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 95.9,
    cy: 127.18,
    r: 15.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-181",
    cx: 95.9,
    cy: 127.18,
    r: 12.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M95.9,92.61c-19.1,0-34.57,15.48-34.57,34.58s15.48,34.58,34.57,34.58,34.57-15.48,34.57-34.58-15.48-34.58-34.57-34.58ZM95.9,152.53c-14,0-25.35-11.35-25.35-25.35s11.35-25.35,25.35-25.35,25.35,11.35,25.35,25.35-11.35,25.35-25.35,25.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M95.9,96.2c-17.11,0-30.98,13.87-30.98,30.98s13.87,30.98,30.98,30.98,30.98-13.87,30.98-30.98-13.87-30.98-30.98-30.98ZM95.9,149.9c-12.55,0-22.72-10.17-22.72-22.72s10.17-22.72,22.72-22.72,22.72,10.17,22.72,22.72-10.17,22.72-22.72,22.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 95.05,
    y: 93.59,
    width: 1.85,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 92.3,
    y: 93.71,
    width: 1.85,
    height: 4.1,
    transform: "translate(-7.99 8.49) rotate(-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 89.57,
    y: 94.06,
    width: 1.85,
    height: 4.1,
    transform: "translate(-15.32 17.18) rotate(-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 86.88,
    y: 94.65,
    width: 1.85,
    height: 4.1,
    transform: "translate(-22.03 26.02) rotate(-15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 84.26,
    y: 95.47,
    width: 1.85,
    height: 4.1,
    transform: "translate(-28.22 35.02) rotate(-20)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 81.71,
    y: 96.52,
    width: 1.85,
    height: 4.1,
    transform: "translate(-33.92 44.17) rotate(-25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 79.27,
    y: 97.78,
    width: 1.85,
    height: 4.1,
    transform: "translate(-39.17 53.47) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 76.94,
    y: 99.26,
    width: 1.85,
    height: 4.1,
    transform: "translate(-44.03 62.99) rotate(-35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 74.76,
    y: 100.93,
    width: 1.85,
    height: 4.1,
    transform: "translate(-48.49 72.74) rotate(-40)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 72.73,
    y: 102.78,
    width: 1.85,
    height: 4.1,
    transform: "translate(-52.56 82.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 70.86,
    y: 104.81,
    width: 1.85,
    height: 4.1,
    transform: "translate(-56.22 93.17) rotate(-50.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 69.18,
    y: 106.99,
    width: 1.85,
    height: 4.1,
    transform: "translate(-59.42 103.94) rotate(-55.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 67.7,
    y: 109.3,
    width: 1.85,
    height: 4.1,
    transform: "translate(-62.12 115.11) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 66.42,
    y: 111.74,
    width: 1.85,
    height: 4.1,
    transform: "translate(-64.25 126.74) rotate(-65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 65.36,
    y: 114.28,
    width: 1.85,
    height: 4.1,
    transform: "translate(-65.7 138.84) rotate(-70)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 64.53,
    y: 116.9,
    width: 1.85,
    height: 4.1,
    transform: "translate(-66.39 151.4) rotate(-75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 63.93,
    y: 119.59,
    width: 1.85,
    height: 4.1,
    transform: "translate(-66.2 164.39) rotate(-80)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 63.57,
    y: 122.32,
    width: 1.85,
    height: 4.1,
    transform: "translate(-65.02 177.78) rotate(-85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 63.44,
    y: 125.06,
    width: 1.85,
    height: 4.1,
    transform: "translate(-62.75 191.48) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 63.55,
    y: 127.81,
    width: 1.85,
    height: 4.1,
    transform: "translate(-59.27 205.42) rotate(-95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 63.91,
    y: 130.54,
    width: 1.85,
    height: 4.1,
    transform: "translate(-54.49 219.47) rotate(-100)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 64.5,
    y: 133.23,
    width: 1.85,
    height: 4.1,
    transform: "translate(-48.32 233.48) rotate(-105)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 65.32,
    y: 135.86,
    width: 1.85,
    height: 4.1,
    transform: "translate(-40.69 247.32) rotate(-110)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 66.37,
    y: 138.4,
    width: 1.85,
    height: 4.1,
    transform: "translate(-31.56 260.8) rotate(-115)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 67.63,
    y: 140.84,
    width: 1.85,
    height: 4.1,
    transform: "translate(-20.92 273.71) rotate(-120)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 69.1,
    y: 143.17,
    width: 1.85,
    height: 4.1,
    transform: "translate(-8.77 285.87) rotate(-125)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 70.77,
    y: 145.35,
    width: 1.85,
    height: 4.1,
    transform: "translate(4.86 297.08) rotate(-130)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 72.63,
    y: 147.39,
    width: 1.85,
    height: 4.1,
    transform: "translate(19.89 307.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 74.65,
    y: 149.25,
    width: 1.85,
    height: 4.1,
    transform: "translate(36.21 315.79) rotate(-140)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 76.83,
    y: 150.93,
    width: 1.85,
    height: 4.1,
    transform: "translate(53.7 322.9) rotate(-145)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 79.15,
    y: 152.41,
    width: 1.85,
    height: 4.1,
    transform: "translate(72.18 328.27) rotate(-150)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 81.59,
    y: 153.69,
    width: 1.85,
    height: 4.1,
    transform: "translate(91.47 331.76) rotate(-155)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 84.13,
    y: 154.75,
    width: 1.85,
    height: 4.1,
    transform: "translate(111.35 333.23) rotate(-160)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 86.75,
    y: 155.58,
    width: 1.85,
    height: 4.1,
    transform: "translate(131.56 332.59) rotate(-165)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 89.44,
    y: 156.18,
    width: 1.85,
    height: 4.1,
    transform: "translate(151.87 329.76) rotate(-170)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 92.16,
    y: 156.55,
    width: 1.85,
    height: 4.1,
    transform: "translate(172 324.71) rotate(-175)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 94.91,
    y: 156.67,
    width: 1.85,
    height: 4.1,
    transform: "translate(191.67 317.45) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 97.66,
    y: 156.56,
    width: 1.85,
    height: 4.1,
    transform: "translate(210.61 308.03) rotate(175)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 100.39,
    y: 156.21,
    width: 1.85,
    height: 4.1,
    transform: "translate(228.57 296.52) rotate(170)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 103.08,
    y: 155.62,
    width: 1.85,
    height: 4.1,
    transform: "translate(245.26 283.05) rotate(165)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 105.7,
    y: 154.79,
    width: 1.85,
    height: 4.1,
    transform: "translate(260.47 267.76) rotate(160)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 108.25,
    y: 153.75,
    width: 1.85,
    height: 4.1,
    transform: "translate(273.96 250.86) rotate(155)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 110.69,
    y: 152.48,
    width: 1.85,
    height: 4.1,
    transform: "translate(285.54 232.55) rotate(150)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 113.01,
    y: 151.01,
    width: 1.85,
    height: 4.1,
    transform: "translate(295.06 213.08) rotate(145)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 115.2,
    y: 149.34,
    width: 1.85,
    height: 4.1,
    transform: "translate(302.39 192.72) rotate(140)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 117.23,
    y: 147.48,
    width: 1.85,
    height: 4.1,
    transform: "translate(307.45 171.72) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 119.1,
    y: 145.46,
    width: 1.85,
    height: 4.1,
    transform: "translate(310.17 150.38) rotate(130)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 120.78,
    y: 143.28,
    width: 1.85,
    height: 4.1,
    transform: "translate(310.55 128.99) rotate(125)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 122.26,
    y: 140.96,
    width: 1.85,
    height: 4.1,
    transform: "translate(308.63 107.84) rotate(120)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 123.54,
    y: 138.52,
    width: 1.85,
    height: 4.1,
    transform: "translate(304.46 87.18) rotate(115)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 124.59,
    y: 135.98,
    width: 1.85,
    height: 4.1,
    transform: "translate(298.16 67.29) rotate(110)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 125.43,
    y: 133.36,
    width: 1.85,
    height: 4.1,
    transform: "translate(289.85 48.41) rotate(105)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 126.03,
    y: 130.68,
    width: 1.85,
    height: 4.1,
    transform: "translate(279.71 30.75) rotate(100)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 126.39,
    y: 127.95,
    width: 1.85,
    height: 4.1,
    transform: "translate(267.92 14.5) rotate(95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 126.52,
    y: 125.2,
    width: 1.85,
    height: 4.1,
    transform: "translate(254.7 -.19) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 126.41,
    y: 122.45,
    width: 1.85,
    height: 4.1,
    transform: "translate(240.26 -13.19) rotate(85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 126.05,
    y: 119.72,
    width: 1.85,
    height: 4.1,
    transform: "translate(224.85 -24.42) rotate(80)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 125.46,
    y: 117.03,
    width: 1.85,
    height: 4.1,
    transform: "translate(208.7 -33.82) rotate(75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 124.64,
    y: 114.41,
    width: 1.85,
    height: 4.1,
    transform: "translate(192.06 -41.36) rotate(70)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 123.59,
    y: 111.86,
    width: 1.85,
    height: 4.1,
    transform: "translate(175.13 -47.08) rotate(65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 122.33,
    y: 109.42,
    width: 1.85,
    height: 4.1,
    transform: "translate(158.17 -51) rotate(60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 120.85,
    y: 107.1,
    width: 1.85,
    height: 4.1,
    transform: "translate(141.34 -53.21) rotate(55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 119.18,
    y: 104.91,
    width: 1.85,
    height: 4.1,
    transform: "translate(124.84 -53.8) rotate(50)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 117.33,
    y: 102.88,
    width: 1.85,
    height: 4.1,
    transform: "translate(108.83 -52.88) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 115.3,
    y: 101.01,
    width: 1.85,
    height: 4.1,
    transform: "translate(93.45 -50.6) rotate(40)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 113.13,
    y: 99.33,
    width: 1.85,
    height: 4.1,
    transform: "translate(78.78 -47.08) rotate(35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 110.81,
    y: 97.85,
    width: 1.85,
    height: 4.1,
    transform: "translate(64.92 -42.48) rotate(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 108.37,
    y: 96.58,
    width: 1.85,
    height: 4.1,
    transform: "translate(51.93 -36.95) rotate(25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 105.83,
    y: 95.52,
    width: 1.85,
    height: 4.1,
    transform: "translate(39.81 -30.63) rotate(20)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 103.21,
    y: 94.68,
    width: 1.85,
    height: 4.1,
    transform: "translate(28.59 -23.66) rotate(15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 100.52,
    y: 94.08,
    width: 1.85,
    height: 4.1,
    transform: "translate(18.24 -16.16) rotate(10)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 97.8,
    y: 93.72,
    width: 1.85,
    height: 4.1,
    transform: "translate(8.73 -8.24) rotate(5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M113.44,132.83h0c-1.66.44-3.37-.54-3.81-2.2l-2.92-10.9c-.44-1.66.54-3.37,2.2-3.81h0c1.66-.44,3.37.54,3.81,2.2l2.92,10.9c.44,1.66-.54,3.37-2.2,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M95.9,102.03c-13.89,0-25.15,11.26-25.15,25.15s11.26,25.15,25.15,25.15,25.15-11.26,25.15-25.15-11.26-25.15-25.15-25.15ZM95.9,145.49c-10.11,0-18.31-8.2-18.31-18.31s8.2-18.31,18.31-18.31,18.31,8.2,18.31,18.31-8.2,18.31-18.31,18.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M105.56,132.76c1.53-2.64,5.88-3.25,11.4-2.07.19-1.14.31-2.31.31-3.51s-.12-2.37-.31-3.51c-5.52,1.18-9.88.57-11.4-2.07-1.53-2.65.13-6.73,3.93-10.93-1.8-1.49-3.87-2.66-6.09-3.5-1.74,5.37-4.44,8.85-7.49,8.85s-5.75-3.47-7.49-8.85c-2.23.84-4.29,2.01-6.09,3.5,3.79,4.2,5.45,8.28,3.93,10.93-1.53,2.64-5.88,3.25-11.4,2.07-.19,1.14-.31,2.31-.31,3.51s.12,2.37.31,3.51c5.52-1.18,9.88-.57,11.4,2.07,1.53,2.65-.13,6.73-3.93,10.93,1.8,1.49,3.87,2.66,6.09,3.5,1.74-5.37,4.44-8.85,7.49-8.85s5.75,3.47,7.49,8.85c2.23-.84,4.29-2.01,6.09-3.5-3.79-4.2-5.45-8.28-3.93-10.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M118.41,129.29c.07-.69.11-1.39.11-2.1s-.04-1.41-.11-2.1c-.62-6.72-4.18-12.57-9.38-16.29-.03-.02-.06-.05-.1-.07-.54-.38-1.1-.74-1.68-1.07-.02-.01-.03-.02-.05-.03-3.33-1.93-7.18-3.05-11.3-3.05s-7.98,1.12-11.3,3.05c-.02.01-.03.02-.05.03-.57.34-1.14.69-1.68,1.07-.03.02-.06.05-.1.07-.53.38-1.05.78-1.55,1.2,0,0,0,0,0,0h0c-4.35,3.72-7.28,9.06-7.83,15.08-.07.69-.11,1.39-.11,2.1s.04,1.41.11,2.1c.62,6.72,4.18,12.57,9.38,16.29.03.02.06.05.09.07.54.38,1.1.74,1.68,1.07.02,0,.03.02.05.03,3.33,1.93,7.18,3.05,11.3,3.05s7.98-1.12,11.3-3.05c.02-.01.03-.02.05-.03.57-.33,1.13-.69,1.68-1.07.03-.02.06-.05.1-.07.53-.38,1.05-.78,1.55-1.2,0,0,0,0,0,0h0c4.35-3.72,7.28-9.06,7.83-15.08ZM116.24,123.65c-5.71,1.6-10.35,1.24-11.85-1.36-1.51-2.61.51-6.81,4.76-10.96,3.67,3.07,6.25,7.4,7.1,12.32ZM103.01,107.81c-1.47,5.74-4.1,9.58-7.11,9.58s-5.64-3.84-7.11-9.58c2.22-.81,4.61-1.28,7.11-1.28s4.89.47,7.11,1.28ZM82.67,111.33c4.24,4.15,6.26,8.35,4.76,10.96-1.5,2.61-6.15,2.96-11.85,1.36.85-4.92,3.42-9.25,7.1-12.32ZM75.57,130.72c5.71-1.6,10.35-1.24,11.85,1.36,1.51,2.61-.51,6.81-4.76,10.96-3.67-3.07-6.25-7.4-7.1-12.32ZM88.8,146.56c1.47-5.74,4.1-9.58,7.11-9.58s5.64,3.84,7.11,9.58c-2.22.81-4.61,1.28-7.11,1.28s-4.89-.47-7.11-1.28ZM104.38,132.08c1.5-2.61,6.15-2.96,11.85-1.36-.85,4.92-3.42,9.25-7.1,12.32-4.24-4.15-6.26-8.35-4.76-10.96Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-203",
    cx: 95.9,
    cy: 127.18,
    r: 8.14,
    transform: "translate(-34.4 218.8) rotate(-88.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M101.66,127.18c0,3.18-2.58,5.76-5.76,5.76s-5.76-2.58-5.76-5.76,2.58-5.76,5.76-5.76,5.76,2.58,5.76,5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M100.06,127.18c0,2.29-1.86,4.15-4.15,4.15s-4.15-1.86-4.15-4.15,1.86-4.15,4.15-4.15,4.15,1.86,4.15,4.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-188",
    cx: 375.79,
    cy: 127.18,
    r: 15.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-181",
    cx: 375.79,
    cy: 127.18,
    r: 12.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M375.79,92.61c-19.09,0-34.57,15.48-34.57,34.58s15.48,34.58,34.57,34.58,34.57-15.48,34.57-34.58-15.48-34.58-34.57-34.58ZM375.79,152.53c-14,0-25.35-11.35-25.35-25.35s11.35-25.35,25.35-25.35,25.35,11.35,25.35,25.35-11.35,25.35-25.35,25.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M375.79,96.2c-17.11,0-30.98,13.87-30.98,30.98s13.87,30.98,30.98,30.98,30.98-13.87,30.98-30.98-13.87-30.98-30.98-30.98ZM375.79,149.9c-12.55,0-22.72-10.17-22.72-22.72s10.17-22.72,22.72-22.72,22.72,10.17,22.72,22.72-10.17,22.72-22.72,22.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 374.93,
    y: 93.59,
    width: 1.85,
    height: 4.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 372.18,
    y: 93.71,
    width: 1.85,
    height: 4.1,
    transform: "translate(-6.92 32.87) rotate(-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 369.45,
    y: 94.06,
    width: 1.85,
    height: 4.1,
    transform: "translate(-11.06 65.78) rotate(-10)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 366.77,
    y: 94.65,
    width: 1.85,
    height: 4.1,
    transform: "translate(-12.5 98.46) rotate(-15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 364.14,
    y: 95.47,
    width: 1.85,
    height: 4.1,
    transform: "translate(-11.34 130.75) rotate(-20)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 361.6,
    y: 96.52,
    width: 1.85,
    height: 4.1,
    transform: "translate(-7.69 162.46) rotate(-25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 359.15,
    y: 97.78,
    width: 1.85,
    height: 4.1,
    transform: "translate(-1.68 193.42) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 356.83,
    y: 99.26,
    width: 1.85,
    height: 4.1,
    transform: "translate(6.59 223.53) rotate(-35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 354.64,
    y: 100.93,
    width: 1.85,
    height: 4.1,
    transform: "translate(17 252.67) rotate(-40)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 352.61,
    y: 102.78,
    width: 1.85,
    height: 4.1,
    transform: "translate(29.42 280.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 350.75,
    y: 104.81,
    width: 1.85,
    height: 4.1,
    transform: "translate(43.78 307.6) rotate(-50.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 349.07,
    y: 106.99,
    width: 1.85,
    height: 4.1,
    transform: "translate(59.94 333.21) rotate(-55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 347.58,
    y: 109.3,
    width: 1.85,
    height: 4.1,
    transform: "translate(77.81 357.49) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 346.31,
    y: 111.74,
    width: 1.85,
    height: 4.1,
    transform: "translate(97.35 380.4) rotate(-65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 345.25,
    y: 114.28,
    width: 1.85,
    height: 4.1,
    transform: "translate(118.46 401.84) rotate(-70)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 344.42,
    y: 116.9,
    width: 1.85,
    height: 4.1,
    transform: "translate(141.07 421.75) rotate(-75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 343.82,
    y: 119.59,
    width: 1.85,
    height: 4.1,
    transform: "translate(165.1 440.03) rotate(-80)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 343.45,
    y: 122.32,
    width: 1.85,
    height: 4.1,
    transform: "translate(190.47 456.6) rotate(-85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 343.32,
    y: 125.06,
    width: 1.85,
    height: 4.1,
    transform: "translate(217.13 471.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 343.44,
    y: 127.81,
    width: 1.85,
    height: 4.1,
    transform: "translate(245.01 484.24) rotate(-95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 343.79,
    y: 130.54,
    width: 1.85,
    height: 4.1,
    transform: "translate(273.98 495.1) rotate(-100)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 344.38,
    y: 133.23,
    width: 1.85,
    height: 4.1,
    transform: "translate(304.01 503.84) rotate(-105)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 345.2,
    y: 135.86,
    width: 1.85,
    height: 4.1,
    transform: "translate(334.9 510.33) rotate(-110)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 346.25,
    y: 138.4,
    width: 1.85,
    height: 4.1,
    transform: "translate(366.58 514.46) rotate(-115)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 347.52,
    y: 140.84,
    width: 1.85,
    height: 4.1,
    transform: "translate(398.9 516.1) rotate(-120)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 348.99,
    y: 143.17,
    width: 1.85,
    height: 4.1,
    transform: "translate(431.64 515.15) rotate(-125)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 350.66,
    y: 145.35,
    width: 1.85,
    height: 4.1,
    transform: "translate(464.65 511.49) rotate(-130)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 352.51,
    y: 147.39,
    width: 1.85,
    height: 4.1,
    transform: "translate(497.67 505.03) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 354.54,
    y: 149.25,
    width: 1.85,
    height: 4.1,
    transform: "translate(530.49 495.7) rotate(-140)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 356.72,
    y: 150.93,
    width: 1.85,
    height: 4.1,
    transform: "translate(562.85 483.44) rotate(-145)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 359.04,
    y: 152.41,
    width: 1.85,
    height: 4.1,
    transform: "translate(594.46 468.22) rotate(-150)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 361.47,
    y: 153.69,
    width: 1.85,
    height: 4.1,
    transform: "translate(625.03 450.04) rotate(-155)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 364.01,
    y: 154.75,
    width: 1.85,
    height: 4.1,
    transform: "translate(654.25 428.95) rotate(-160)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 366.64,
    y: 155.58,
    width: 1.85,
    height: 4.1,
    transform: "translate(681.78 405.04) rotate(-165)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 369.32,
    y: 156.18,
    width: 1.85,
    height: 4.1,
    transform: "translate(707.38 378.36) rotate(-170)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 372.05,
    y: 156.55,
    width: 1.85,
    height: 4.1,
    transform: "translate(730.71 349.09) rotate(-175)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 374.8,
    y: 156.67,
    width: 1.85,
    height: 4.1,
    transform: "translate(751.44 317.45) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 377.55,
    y: 156.56,
    width: 1.85,
    height: 4.1,
    transform: "translate(769.32 283.64) rotate(175)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 380.27,
    y: 156.21,
    width: 1.85,
    height: 4.1,
    transform: "translate(784.09 247.91) rotate(170)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 382.96,
    y: 155.62,
    width: 1.85,
    height: 4.1,
    transform: "translate(795.5 210.62) rotate(165)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 385.59,
    y: 154.79,
    width: 1.85,
    height: 4.1,
    transform: "translate(803.36 172.03) rotate(160)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 388.13,
    y: 153.75,
    width: 1.85,
    height: 4.1,
    transform: "translate(807.5 132.56) rotate(155)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 390.58,
    y: 152.48,
    width: 1.85,
    height: 4.1,
    transform: "translate(807.81 92.59) rotate(150)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 392.9,
    y: 151.01,
    width: 1.85,
    height: 4.1,
    transform: "translate(804.21 52.53) rotate(145)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 395.09,
    y: 149.34,
    width: 1.85,
    height: 4.1,
    transform: "translate(796.68 12.8) rotate(140)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 397.12,
    y: 147.48,
    width: 1.85,
    height: 4.1,
    transform: "translate(785.24 -26.19) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 398.98,
    y: 145.46,
    width: 1.85,
    height: 4.1,
    transform: "translate(769.95 -64.04) rotate(130)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 400.66,
    y: 143.28,
    width: 1.85,
    height: 4.1,
    transform: "translate(750.97 -100.27) rotate(125)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 402.14,
    y: 140.96,
    width: 1.85,
    height: 4.1,
    transform: "translate(728.45 -134.55) rotate(120)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 403.42,
    y: 138.52,
    width: 1.85,
    height: 4.1,
    transform: "translate(702.63 -166.48) rotate(115)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 404.48,
    y: 135.98,
    width: 1.85,
    height: 4.1,
    transform: "translate(673.75 -195.72) rotate(110)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 405.31,
    y: 133.36,
    width: 1.85,
    height: 4.1,
    transform: "translate(642.15 -221.95) rotate(105)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 405.91,
    y: 130.68,
    width: 1.85,
    height: 4.1,
    transform: "translate(608.2 -244.88) rotate(100)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 406.28,
    y: 127.95,
    width: 1.85,
    height: 4.1,
    transform: "translate(572.21 -264.32) rotate(95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 406.4,
    y: 125.2,
    width: 1.85,
    height: 4.1,
    transform: "translate(534.58 -280.08) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 406.29,
    y: 122.45,
    width: 1.85,
    height: 4.1,
    transform: "translate(495.76 -292.01) rotate(85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 405.94,
    y: 119.72,
    width: 1.85,
    height: 4.1,
    transform: "translate(456.13 -300.05) rotate(80)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 405.35,
    y: 117.03,
    width: 1.85,
    height: 4.1,
    transform: "translate(416.14 -304.16) rotate(75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 404.53,
    y: 114.41,
    width: 1.85,
    height: 4.1,
    transform: "translate(376.24 -304.37) rotate(70)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 403.48,
    y: 111.86,
    width: 1.85,
    height: 4.1,
    transform: "translate(336.73 -300.74) rotate(65)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 402.21,
    y: 109.42,
    width: 1.85,
    height: 4.1,
    transform: "translate(298.11 -293.39) rotate(60)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 400.74,
    y: 107.1,
    width: 1.85,
    height: 4.1,
    transform: "translate(260.71 -282.49) rotate(55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 399.07,
    y: 104.91,
    width: 1.85,
    height: 4.1,
    transform: "translate(224.83 -268.21) rotate(50)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 397.21,
    y: 102.88,
    width: 1.85,
    height: 4.1,
    transform: "translate(190.82 -250.8) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 395.19,
    y: 101.01,
    width: 1.85,
    height: 4.1,
    transform: "translate(158.94 -230.52) rotate(40)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 393.01,
    y: 99.33,
    width: 1.85,
    height: 4.1,
    transform: "translate(129.38 -207.6) rotate(35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 390.69,
    y: 97.85,
    width: 1.85,
    height: 4.1,
    transform: "translate(102.41 -182.42) rotate(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 388.26,
    y: 96.58,
    width: 1.85,
    height: 4.1,
    transform: "translate(78.16 -155.25) rotate(25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 385.72,
    y: 95.52,
    width: 1.85,
    height: 4.1,
    transform: "translate(56.69 -126.36) rotate(20)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 383.09,
    y: 94.68,
    width: 1.85,
    height: 4.1,
    transform: "translate(38.13 -96.1) rotate(15)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 380.41,
    y: 94.08,
    width: 1.85,
    height: 4.1,
    transform: "translate(22.49 -64.76) rotate(10)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 377.68,
    y: 93.72,
    width: 1.85,
    height: 4.1,
    transform: "translate(9.79 -32.64) rotate(5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M393.32,132.83h0c-1.66.44-3.37-.54-3.81-2.2l-2.92-10.9c-.44-1.66.54-3.37,2.2-3.81h0c1.66-.44,3.37.54,3.81,2.2l2.92,10.9c.44,1.66-.54,3.37-2.2,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M375.79,102.03c-13.89,0-25.15,11.26-25.15,25.15s11.26,25.15,25.15,25.15,25.15-11.26,25.15-25.15-11.26-25.15-25.15-25.15ZM375.79,145.49c-10.11,0-18.31-8.2-18.31-18.31s8.2-18.31,18.31-18.31,18.31,8.2,18.31,18.31-8.2,18.31-18.31,18.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M385.45,132.76c1.53-2.64,5.88-3.25,11.4-2.07.19-1.14.31-2.31.31-3.51s-.12-2.37-.31-3.51c-5.52,1.18-9.88.57-11.4-2.07-1.53-2.65.13-6.73,3.93-10.93-1.8-1.49-3.87-2.66-6.09-3.5-1.74,5.37-4.44,8.85-7.49,8.85s-5.75-3.47-7.49-8.85c-2.23.84-4.29,2.01-6.09,3.5,3.79,4.2,5.45,8.28,3.93,10.93-1.53,2.64-5.88,3.25-11.4,2.07-.19,1.14-.31,2.31-.31,3.51s.12,2.37.31,3.51c5.52-1.18,9.88-.57,11.4,2.07,1.53,2.65-.13,6.73-3.93,10.93,1.8,1.49,3.87,2.66,6.09,3.5,1.74-5.37,4.44-8.85,7.49-8.85s5.75,3.47,7.49,8.85c2.23-.84,4.29-2.01,6.09-3.5-3.79-4.2-5.45-8.28-3.93-10.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M398.3,129.29c.07-.69.11-1.39.11-2.1s-.04-1.41-.11-2.1c-.62-6.72-4.18-12.57-9.38-16.29-.03-.02-.06-.05-.1-.07-.54-.38-1.1-.74-1.68-1.07-.02-.01-.03-.02-.05-.03-3.33-1.93-7.18-3.05-11.3-3.05s-7.98,1.12-11.3,3.05c-.02.01-.03.02-.05.03-.58.34-1.14.69-1.68,1.07-.03.02-.06.05-.1.07-.53.38-1.05.78-1.55,1.2,0,0,0,0,0,0h0c-4.35,3.72-7.28,9.06-7.83,15.08-.07.69-.11,1.39-.11,2.1s.04,1.41.11,2.1c.62,6.72,4.18,12.57,9.38,16.29.03.02.06.05.09.07.54.38,1.1.74,1.68,1.07.02,0,.03.02.05.03,3.33,1.93,7.18,3.05,11.3,3.05s7.98-1.12,11.3-3.05c.02-.01.03-.02.05-.03.57-.33,1.14-.69,1.68-1.07.03-.02.06-.05.1-.07.53-.38,1.05-.78,1.55-1.2,0,0,0,0,0,0h0c4.35-3.72,7.28-9.06,7.83-15.08ZM396.12,123.65c-5.71,1.6-10.35,1.24-11.85-1.36-1.51-2.61.51-6.81,4.76-10.96,3.67,3.07,6.25,7.4,7.1,12.32ZM382.89,107.81c-1.47,5.74-4.1,9.58-7.11,9.58s-5.64-3.84-7.11-9.58c2.22-.81,4.6-1.28,7.11-1.28s4.89.47,7.11,1.28ZM362.55,111.33c4.24,4.15,6.26,8.35,4.76,10.96-1.5,2.61-6.15,2.96-11.85,1.36.85-4.92,3.42-9.25,7.1-12.32ZM355.45,130.72c5.71-1.6,10.35-1.24,11.85,1.36,1.51,2.61-.51,6.81-4.76,10.96-3.67-3.07-6.25-7.4-7.1-12.32ZM368.68,146.56c1.47-5.74,4.1-9.58,7.11-9.58s5.64,3.84,7.11,9.58c-2.22.81-4.61,1.28-7.11,1.28s-4.89-.47-7.11-1.28ZM384.27,132.08c1.5-2.61,6.15-2.96,11.85-1.36-.85,4.92-3.42,9.25-7.1,12.32-4.24-4.15-6.26-8.35-4.76-10.96Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-203",
    cx: 375.79,
    cy: 127.18,
    r: 8.14,
    transform: "translate(235.29 498.2) rotate(-87.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M381.55,127.18c0,3.18-2.58,5.76-5.76,5.76s-5.76-2.58-5.76-5.76,2.58-5.76,5.76-5.76,5.76,2.58,5.76,5.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M379.94,127.18c0,2.29-1.86,4.15-4.15,4.15s-4.15-1.86-4.15-4.15,1.86-4.15,4.15-4.15,4.15,1.86,4.15,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M461.56,89.82c-1.76-1.05-2.45-3.27-2.25-5.31.75-7.48.81-28.69-7.38-33.82-1.1-.69-2.18-1.36-3.26-2.03-13.45,0-26.68-3.46-38.42-10.03l-27.62-15.48c-1.2-.67.75-9.21,5.3-11.49,2.28-1.15-31.53-16.05-148.27-10.37-6.56.32-20.17,3.4-31.42,7.08l2.21,2.9c.04.05.05.12.04.19-.02.06-.06.12-.12.14-.23.1-23.69,10.07-37.77,18.39-14.1,8.32-31.77,19.29-31.95,19.4-.02.01-.04.02-.06.03-.05.01-3.04.71-7.72.71-3.14,0-7.03-.31-11.32-1.35-.09-.02-.15-.09-.16-.18,0,0,0,0,0-.01-.46,0-1.85.02-4.05.07-17.52.42-57.31,9.37-86.99,23.94C11.86,81.66,4.2,97.71,1.41,112.41c-.09.47.36.84.82.71,5.58-1.64,11.84.1,15.36,5.06.24.34.47.69.68,1.04l1.53,2.58c1.21,2.04-.39,4.54-2.92,4.54H1.14c-.62,0-1.13.51-1.14,1.13,0,.45,0,.9,0,1.34.01,1.27.83,2.39,2.03,2.79,11.92,3.99,24.05,7.46,38.55,9.16,6.03.7,9.99,1.1,9.99,1.1-.14-1.73-.21-3.47-.21-5.24,0-30.35,20.39-54.95,45.53-54.95s45.53,24.6,45.53,54.95c0,1.85-.08,3.68-.23,5.48h189.2c-.15-1.8-.23-3.63-.23-5.48,0-30.35,20.39-54.95,45.53-54.95s45.53,24.6,45.53,54.95c0,1.69-.07,3.35-.2,5l9.06-1.38s36.12-10.52,36.12-20.46c0-8.63,0-27.15-4.68-29.94ZM252.1,52.24c-39.5,2.37-98.88,2.37-98.88,2.37,0,0,31.91-23.8,70.89-38.72,4.71-1.8,19.47-3.18,36.61-3.85l-8.62,40.2ZM362.45,33.84c-3.84,3.44-9.76,8.13-14.11,8.93-6.4,1.16-40.76,4.92-75.96,7.93l4.97-39.07c19.36-.22,38.68.49,48.24,2.46,15.97,3.31,29.41,9.76,36.14,13.39,2.39,1.29,2.74,4.55.72,6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M375.72,72.58c-26.53-.42-241.02,7.99-244.46,33.28.12.41.23.79.35,1.2,2.38,3.26,16.18,18.59,62.68,13.78l140.79-6.43c6.63-18.52,22.35-31.54,40.7-31.54,10.92,0,20.91,4.63,28.6,12.27,0,0-2.72-22.15-28.66-22.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M375.72,72.58c-21.56,0-40.82,14.31-50.27,37.36-2.83,6.91-9.35,11.6-16.61,11.96l-154.18,8.19c-1.87.1-3.5-1.25-3.79-3.13-4.87-31.51-27.99-54.37-54.97-54.37-13.2,0-26.01,5.57-36.07,15.68-12.7,12.76-19.93,31.42-19.83,51.19,0,.37.13.74.35,1.03.23.31.57.53.94.63l12.09,3.12c.14.04.28.05.43.05.39,0,.77-.13,1.08-.38.42-.34.66-.87.63-1.41-.07-1.39-.12-5.03-.12-6.47,0-30.27,16.27-50.6,40.49-50.6s40.49,20.33,40.49,50.6c0,1.43-.05,5.06-.12,6.47-.03.52.19,1.03.58,1.37.39.34.92.48,1.44.39l11.92-2.19h171.19l11.99,2.19c.52.1,1.04-.05,1.44-.4.39-.34.61-.85.58-1.37-.07-1.39-.12-5.03-.12-6.47,0-30.27,16.27-50.6,40.49-50.6s40.49,20.33,40.49,50.6c0,1.44-.05,5.07-.12,6.47-.03.56.23,1.11.68,1.45.45.34,1.04.43,1.58.26l12.02-4.04c.7-.24,1.17-.89,1.17-1.63-.24-36.36-25.31-65.94-55.89-65.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M150.06,142.08c0-.44.03-.87.03-1.31,0-35.77-24.26-64.76-54.19-64.76s-54.19,28.99-54.19,64.76c0,.14,0,.27,0,.41l12.09,3.12c-.07-1.43-.12-5.09-.12-6.55,0-33.68,18.9-52.31,42.21-52.31s42.21,18.63,42.21,52.31c0,1.46-.05,5.12-.12,6.55l12.07-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M429.9,140.25c-.23-35.53-24.39-64.24-54.18-64.24s-54.19,28.99-54.19,64.76c0,.44.02.87.03,1.31l12.14,2.22c-.07-1.43-.12-5.09-.12-6.55,0-33.68,18.9-52.31,42.21-52.31s42.21,18.63,42.21,52.31c0,1.46-.05,5.12-.12,6.55l12.02-4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M319.39,136.2c0-1.88-2.9-3.37-6.36-3.29l-153.06,4.19c-1.03.03-1.83.44-2.02.96l161.42-1.75s.02-.08.02-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M157.95,138.06c-.03.08-.08.15-.08.23,0,.66.99,1.2,2.21,1.2h153.24c3.28,0,5.94-1.41,6.06-3.17l-161.42,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M182.14,38.71h-.59c-7.02,0-12.91,4.39-14.65,10.35l-2.19,2.01c-.89.82-1.06,2.15-.26,3.04.91,1.03,2.57,1.08,3.56.17l1.75-1.61h11.58c4.1,0,4.95-3.06,4.95-6.83v-1.58c0-3.07-.82-5.56-4.15-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M174.07,51.47h-3.49c-.4,0-.76-.21-.95-.55l-2.03-3.69c-.04.08-.07.17-.11.25l1.95,3.54c.23.41.67.66,1.15.66h3.49c.58,0,1.04.44,1.07.99h.22c-.03-.67-.59-1.21-1.29-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M466.23,119.76c0-8.63,0-27.15-4.68-29.94-1.76-1.05-2.45-3.27-2.25-5.31.75-7.48.81-28.69-7.38-33.82-1.1-.69-2.18-1.36-3.26-2.03-13.45,0-26.68-3.46-38.42-10.03l-27.62-15.48c-1.2-.67.75-9.21,5.3-11.49,2.28-1.15-31.53-16.05-148.27-10.37-6.56.32-20.17,3.4-31.42,7.08l2.21,2.9c.04.05.05.12.04.19-.02.06-.06.12-.12.14-.23.1-23.69,10.07-37.77,18.39-14.1,8.32-31.77,19.29-31.95,19.4-.02.01-.04.02-.06.03-.05.01-3.04.71-7.72.71-3.14,0-7.03-.31-11.32-1.35-.09-.02-.15-.09-.16-.18,0,0,0,0,0-.01-.46,0-1.85.02-4.05.07-17.52.42-57.31,9.37-86.99,23.94C11.86,81.66,4.2,97.71,1.41,112.41c-.09.47.36.84.82.71,5.58-1.64,11.84.1,15.36,5.06.24.34.47.69.68,1.04l1.53,2.58c1.21,2.04-.39,4.54-2.92,4.54H1.14c-.62,0-1.13.51-1.14,1.13,0,.45,0,.9,0,1.34.01,1.27.83,2.39,2.03,2.79,11.92,3.99,24.05,7.46,38.55,9.16.01,0,.02,0,.04,0,.2.17.42.31.67.38l12.09,3.12c.13.03.27.05.41.05h.02s0,0,0,0h0c.39,0,.77-.13,1.08-.38.42-.34.66-.87.63-1.41-.07-1.39-.12-5.03-.12-6.47,0-28.29,14.22-47.9,35.86-50.34.07,0,.14-.02.22-.03.41-.04.84-.07,1.26-.1,1.04-.08,2.09-.13,3.16-.13s2.12.05,3.17.13c.42.03.84.06,1.25.1.08,0,.15.02.22.03,21.64,2.44,35.85,22.05,35.85,50.34,0,1.43-.05,5.06-.12,6.47-.03.52.19,1.03.58,1.37.31.27.72.38,1.13.38,0,.01,0,.03,0,.05l.2-.04s.07.01.11,0l11.9-2.19h171.22l11.97,2.19s.07,0,.11,0l.19.04s0-.03,0-.04c.41,0,.82-.11,1.13-.38.39-.34.61-.85.58-1.37-.07-1.39-.12-5.03-.12-6.47,0-28.29,14.22-47.9,35.86-50.34.07,0,.14-.02.22-.03.41-.04.84-.07,1.26-.1,1.04-.08,2.09-.13,3.16-.13s2.12.05,3.17.13c.42.03.84.06,1.25.1.08,0,.15.02.22.03,21.64,2.44,35.85,22.05,35.85,50.34,0,1.44-.05,5.07-.12,6.47-.03.56.23,1.11.68,1.45.3.23.67.33,1.03.33,0,0,0,.01,0,.02h.04c.17-.02.34-.04.5-.09l12.02-4.04c.07-.02.12-.07.18-.09,4.34-1.31,35.61-11.06,35.61-20.31ZM277.35,11.63c19.36-.22,38.68.49,48.24,2.46,15.97,3.31,29.41,9.76,36.14,13.39,2.39,1.29,2.74,4.55.72,6.35-3.84,3.44-9.76,8.13-14.11,8.93-6.4,1.16-40.76,4.92-75.96,7.93l4.97-39.07ZM224.11,15.89c4.71-1.8,19.47-3.18,36.61-3.85l-8.62,40.2c-27.45,1.65-64.48,2.15-84.53,2.3.15-.09.31-.14.43-.26l1.75-1.61h11.58c4.1,0,4.95-3.06,4.95-6.83v-1.58c0-3.07-.81-5.56-4.15-5.56h-.59c-1.99,0-3.88.36-5.61,1,12.67-7.6,29.62-16.72,48.18-23.82ZM170.77,42.87c-1.82,1.7-3.18,3.82-3.87,6.19l-2.19,2.01c-.89.82-1.06,2.15-.26,3.04.17.19.39.32.61.45-7.32.05-11.83.05-11.83.05,0,0,6.64-4.95,17.54-11.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-219"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M461.56,89.82c-1.47-.88-2.19-2.59-2.27-4.32-1.77,1.07-3.78,1.86-5.9,1.86h-36.51c-1.82,2.69,23.82,6.15,40.45,5.26,2.15-.12,3.96-.69,5.48-1.48-.38-.57-.79-1.04-1.26-1.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-227"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M456.62,57.04c-1.13-2.8-2.65-5.07-4.69-6.34-1.1-.69-2.18-1.36-3.26-2.03-13.45,0-26.68-3.46-38.42-10.03l-13.97-7.83h-.42l32.57,18.02c8.81,4.87,18.47,7.64,28.19,8.22Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M235.77,5.67c95.11-4.46,137.17,3.77,149.7,8.07.71-.87,1.53-1.61,2.46-2.08,2.28-1.15-31.53-16.05-148.27-10.37-6.56.32-20.17,3.4-31.42,7.08l1.8,2.36c9.92-2.73,20.22-4.8,25.73-5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M362.14,26.73c-6.66-3.6-20.25-10.14-36.37-13.48-21.68-4.49-90.66-2.49-101.97,1.84-38.64,14.79-70.77,38.6-71.09,38.84-.3.22-.42.61-.3.95.12.35.44.59.81.59.71,0,71.51-.04,109.47-3.11,38.68-3.13,78.72-7.47,85.81-8.76,4.47-.81,10.37-5.41,14.52-9.13,1.17-1.04,1.75-2.59,1.57-4.13-.18-1.55-1.08-2.87-2.45-3.61ZM252.1,52.24c-27.45,1.65-64.48,2.15-84.53,2.3-.78.46-1.74.47-2.52.02-7.32.05-11.83.05-11.83.05,0,0,6.64-4.95,17.55-11.74,1.45-1.36,3.21-2.44,5.16-3.16,12.67-7.6,29.62-16.72,48.18-23.82,4.71-1.8,19.47-3.18,36.61-3.85l-8.62,40.2ZM362.45,33.84c-3.84,3.44-9.76,8.13-14.11,8.93-6.4,1.16-40.76,4.92-75.96,7.93l4.97-39.07c19.36-.22,38.68.49,48.24,2.46,15.97,3.31,29.41,9.76,36.14,13.39,2.39,1.29,2.74,4.55.72,6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M175.93,39.72c1.74-.64,3.63-1,5.61-1h.59c3.34,0,4.15,2.49,4.15,5.56v1.58c0,3.77-.85,6.83-4.95,6.83h-11.58l-1.75,1.61c-.13.12-.29.17-.43.26,20.05-.15,57.08-.66,84.53-2.3l8.62-40.2c-17.13.67-31.89,2.04-36.61,3.85-18.56,7.1-35.51,16.22-48.18,23.82ZM166.89,49.06c.69-2.38,2.05-4.49,3.87-6.19-10.9,6.79-17.54,11.74-17.54,11.74,0,0,4.5,0,11.83-.05-.22-.12-.43-.25-.61-.45-.8-.89-.62-2.23.26-3.04l2.19-2.01ZM361.74,27.49c-6.73-3.63-20.17-10.08-36.14-13.39-9.56-1.98-28.88-2.68-48.24-2.46l-4.97,39.07c35.2-3.01,69.57-6.77,75.96-7.93,4.35-.79,10.26-5.49,14.11-8.93,2.02-1.81,1.67-5.06-.72-6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M140.53,49.19s17.69-10.98,31.95-19.4c14.26-8.42,37.8-18.4,37.8-18.4l-2.25-2.96c-40.14,13.19-85.42,39.52-86.44,40.11,10.75,2.6,18.94.64,18.94.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M406.75,66.81h-12.78c-1.35,0-2.45-1.1-2.45-2.45v-8.97c0-1.35,1.1-2.45,2.45-2.45h12.78c1.35,0,2.45,1.1,2.45,2.45v8.97c0,1.35-1.1,2.45-2.45,2.45ZM393.97,53.37c-1.12,0-2.02.91-2.02,2.02v8.97c0,1.11.91,2.02,2.02,2.02h12.78c1.12,0,2.02-.91,2.02-2.02v-8.97c0-1.11-.91-2.02-2.02-2.02h-12.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-229"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M126.58,63.43s103.45-4.75,144.02-7.39c40.87-2.66,129.16-14.68,129.16-14.68,0,0-30.56,7.73-49.26,10.31-64.98,8.96-132.35,12.05-155.82,12.45-23.47.4-70.1,1.57-68.1-.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M210.48,11.24l-2.25-2.96c-.08-.11-.25-.13-.36-.05-.11.09-.13.25-.05.36l2.05,2.69c-2.81,1.2-24.28,10.47-37.53,18.29-13.79,8.14-31.01,18.81-31.92,19.38-.59.13-7.62,1.61-16.89-.23l-.1-.02c-.59-.12-1.19-.25-1.8-.4,0,0-.02,0-.02,0h-.04s-4.25.33-4.25.33c0,0,3.64,3.68,9.5,3.87,8.41.28,13.75-3.07,13.75-3.07.03,0,.05-.02.08-.03.18-.11,17.85-11.08,31.94-19.4,14.09-8.31,37.53-18.29,37.77-18.39.07-.03.13-.09.15-.17.02-.08,0-.16-.04-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M231.63,72.29c1.46,1.46,8.28,2.11,11.39,1.85,3.11-.26,5.58-1.68,5.94-3.3l-17.33,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M230.58,72.37c1.44,2.12,10.19,3.13,14.11,2.81,3.92-.33,6.97-2.33,7.25-4.59l-21.36,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M244.23,65.68c-4.68.39-15.24,3.52-15.01,6.26.23,2.75,11.15,4.08,15.84,3.69,4.68-.39,8.3-2.94,8.07-5.68-.23-2.75-4.21-4.66-8.9-4.27ZM229.98,72.42c-.1-.16-.17-.33-.18-.51-.22-2.62,9.83-5.59,14.29-5.96,4.46-.37,8.26,1.45,8.47,4.06.01.17.01.35,0,.52l-22.58,1.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-232"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M252.56,70.02c-.22-2.62-4.01-4.44-8.47-4.06s-14.51,3.35-14.29,5.96c.01.17.08.34.18.5l22.58-1.89c.02-.17.02-.35,0-.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M339.21,64.01c1.46,1.46,8.28,2.11,11.39,1.85,3.11-.26,5.58-1.68,5.94-3.3l-17.33,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M338.16,64.1c1.44,2.12,10.19,3.13,14.11,2.81,3.92-.33,6.97-2.33,7.25-4.59l-21.36,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M351.81,57.4c-4.68.39-15.24,3.52-15.01,6.26.23,2.75,11.15,4.08,15.84,3.69,4.68-.39,8.3-2.94,8.07-5.68-.23-2.75-4.21-4.66-8.9-4.27ZM337.56,64.15c-.1-.16-.17-.33-.18-.51-.22-2.62,9.83-5.59,14.29-5.96,4.46-.37,8.26,1.45,8.47,4.06.01.17.01.35,0,.52l-22.58,1.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-233"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M360.14,61.74c-.22-2.62-4.01-4.44-8.47-4.06-4.46.37-14.51,3.35-14.29,5.96.01.17.08.34.18.51l22.58-1.89c.02-.17.02-.35,0-.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M446.87,48.44c0-.12-.1-.21-.21-.21-13.05,0-24.24-3.01-36.3-9.78l-32.94-18.46c-.91-.51-7.06-4.95-7.48-9.51-.15-1.61.49-3.04,1.81-4.32-.16-.04-.35-.07-.51-.1-1.28,1.32-1.88,2.8-1.73,4.46.43,4.74,6.76,9.32,7.69,9.85l32.94,18.46c12.13,6.8,23.39,9.83,36.51,9.83.12,0,.21-.1.21-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M459.16,68.42l-34.99-8.5c-1.1-.27-1.91,1.03-1.18,1.9l7.2,8.53c6.35,7.52,15.69,11.86,25.54,11.86h3.75c.21-3.59.23-8.67-.32-13.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M459.57,69.63c-.03-.28-.24-.52-.52-.58l-34.21-8.1c-1.07-.24-1.36.44-.64,1.47l7.19,8.47c6.17,6.74,15.24,10.63,24.8,10.63h3.06c.32,0,.59-.24.61-.55.17-3.06.16-7.16-.29-11.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M427.82,64.72l-3.97-3.39c-.05.27.04.63.36,1.08l7.19,8.47c6.17,6.74,15.24,10.63,24.8,10.63h3.06c.32,0,.59-.24.61-.55.09-1.64.13-3.59.07-5.69-12.41-.4-24.06-4.18-32.11-10.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 433.67,
    y: 65.56,
    width: 1.71,
    height: 6.4,
    rx: 0.47,
    ry: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 433.82,
    y: 65.75,
    width: 1.14,
    height: 4.27,
    rx: 0.32,
    ry: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 435.91,
    y: 65.75,
    width: 1.71,
    height: 8.54,
    rx: 0.55,
    ry: 0.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 436.06,
    y: 66.01,
    width: 1.14,
    height: 5.69,
    rx: 0.36,
    ry: 0.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 438.15,
    y: 66.01,
    width: 1.71,
    height: 9.48,
    rx: 0.58,
    ry: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M438.68,66.29h.37c.21,0,.38.17.38.38v5.55c0,.21-.17.38-.38.38h-.37c-.21,0-.38-.17-.38-.38v-5.55c0-.21.17-.38.38-.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 440.39,
    y: 66.29,
    width: 1.71,
    height: 10.24,
    rx: 0.6,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M440.94,66.6h.34c.22,0,.4.18.4.4v6.03c0,.22-.18.4-.4.4h-.34c-.22,0-.4-.18-.4-.4v-6.03c0-.22.18-.4.4-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M443.26,66.6h.45c.35,0,.63.28.63.63v10.08c0,.35-.28.63-.63.63h-.45c-.35,0-.63-.28-.63-.63v-10.08c0-.35.28-.63.63-.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 442.78,
    y: 66.94,
    width: 1.14,
    height: 7.56,
    rx: 0.42,
    ry: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 444.87,
    y: 66.94,
    width: 1.71,
    height: 12.12,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 445.02,
    y: 67.3,
    width: 1.14,
    height: 8.08,
    rx: 0.43,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 447.11,
    y: 67.3,
    width: 1.71,
    height: 12.26,
    rx: 0.66,
    ry: 0.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 447.26,
    y: 67.66,
    width: 1.14,
    height: 8.18,
    rx: 0.44,
    ry: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 449.35,
    y: 67.66,
    width: 1.71,
    height: 12.09,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 449.5,
    y: 68.02,
    width: 1.14,
    height: 8.06,
    rx: 0.43,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 451.59,
    y: 68.02,
    width: 1.71,
    height: 12.1,
    rx: 0.65,
    ry: 0.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 451.74,
    y: 68.39,
    width: 1.14,
    height: 8.06,
    rx: 0.43,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 454.74,
    y: 69.88,
    width: 1.44,
    height: 10.94,
    rx: 0.57,
    ry: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 454.87,
    y: 70.21,
    width: 0.96,
    height: 7.29,
    rx: 0.38,
    ry: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 456.47,
    y: 69.88,
    width: 1.44,
    height: 10.94,
    rx: 0.57,
    ry: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M456.98,70.21h.2c.21,0,.38.17.38.38v6.53c0,.21-.17.38-.38.38h-.2c-.21,0-.38-.17-.38-.38v-6.53c0-.21.17-.38.38-.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 458.2,
    y: 69.88,
    width: 1.44,
    height: 10.94,
    rx: 0.57,
    ry: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M458.7,70.21h.2c.21,0,.38.17.38.38v6.53c0,.21-.17.38-.38.38h-.2c-.21,0-.38-.17-.38-.38v-6.53c0-.21.17-.38.38-.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 450.5,
    y: 75.79,
    width: 0.72,
    height: 4.33,
    rx: 0.25,
    ry: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 450.56,
    y: 75.92,
    width: 0.48,
    height: 2.88,
    rx: 0.17,
    ry: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 451.54,
    y: 75.79,
    width: 0.72,
    height: 4.33,
    rx: 0.25,
    ry: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 451.6,
    y: 75.92,
    width: 0.48,
    height: 2.88,
    rx: 0.17,
    ry: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 452.58,
    y: 75.79,
    width: 0.72,
    height: 4.33,
    rx: 0.25,
    ry: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 452.64,
    y: 75.92,
    width: 0.48,
    height: 2.88,
    rx: 0.17,
    ry: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 447.11,
    y: 75.79,
    width: 0.7,
    height: 4.33,
    rx: 0.25,
    ry: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 447.17,
    y: 75.92,
    width: 0.47,
    height: 2.88,
    rx: 0.17,
    ry: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 448.13,
    y: 75.79,
    width: 0.7,
    height: 4.33,
    rx: 0.25,
    ry: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 448.19,
    y: 75.92,
    width: 0.47,
    height: 2.88,
    rx: 0.17,
    ry: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 449.15,
    y: 75.79,
    width: 0.7,
    height: 4.33,
    rx: 0.25,
    ry: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 449.22,
    y: 75.92,
    width: 0.47,
    height: 2.88,
    rx: 0.17,
    ry: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 447.11,
    y: 70.47,
    width: 0.95,
    height: 5.06,
    rx: 0.31,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 447.19,
    y: 70.62,
    width: 0.63,
    height: 3.37,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 448.42,
    y: 70.47,
    width: 0.95,
    height: 5.06,
    rx: 0.31,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 448.5,
    y: 70.62,
    width: 0.63,
    height: 3.37,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 449.73,
    y: 70.47,
    width: 0.95,
    height: 5.06,
    rx: 0.31,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 449.81,
    y: 70.62,
    width: 0.63,
    height: 3.37,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 451.04,
    y: 70.47,
    width: 0.95,
    height: 5.06,
    rx: 0.31,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 451.13,
    y: 70.62,
    width: 0.63,
    height: 3.37,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 452.35,
    y: 70.47,
    width: 0.95,
    height: 5.06,
    rx: 0.31,
    ry: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 452.44,
    y: 70.62,
    width: 0.63,
    height: 3.37,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M454.11,81.73v.83c0,1.74,1.42,3.16,3.16,3.16h2.04c-.01-.14-.03-.29-.03-.43h-2.01c-1.5,0-2.73-1.23-2.73-2.73v-.83c0-12.88-.03-27.44-15.7-33.69-.23-.03-.46-.07-.7-.1l-.09.23c16.05,5.99,16.05,20.64,16.05,33.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M439.69,78.62c-7.83,0-15.16,3.85-19.61,10.29l-11.14,16.14c.08.14.15.28.23.42l11.26-16.31c4.37-6.33,11.57-10.11,19.25-10.11h2.35v-.43h-2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M120.89,49.92l-.51-.03c-.51,7.74-38.96,20.71-107.18,36.12-.18.21-.35.43-.52.65,44.67-10.09,107.52-26.11,108.21-36.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M47.52,109.33c-11.56-7.71-20.45-18.82-25.46-31.7-.12.09-.24.17-.36.26,5.05,12.91,13.97,24.05,25.58,31.79l10.63,7.09c.04-.14.08-.29.12-.43l-10.52-7.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M5.16,99.83h12.84c9.85,0,19.2-4.34,25.55-11.86l9.53-11.28-40.1,9.74c-.39.09-.73.32-.98.63-3.03,3.89-5.36,8.07-7.14,12.34-.08.2.07.43.29.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M49.02,79.23l-37.56,8.59c-2.68,3.59-4.81,7.39-6.46,11.29h11.05c2.78,0,5.51-.3,8.15-.87,8.05-1.74,15.11-6.55,20.18-13.05l4.64-5.96Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 9.47,
    y: 90.82,
    width: 1.32,
    height: 7.68,
    rx: 0.46,
    ry: 0.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 9.58,
    y: 91.05,
    width: 0.88,
    height: 5.12,
    rx: 0.3,
    ry: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 7.46,
    y: 94.51,
    width: 1.32,
    height: 3.99,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 7.58,
    y: 94.63,
    width: 0.88,
    height: 2.66,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 11.39,
    y: 93.79,
    width: 1.3,
    height: 4.72,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 11.51,
    y: 93.93,
    width: 0.87,
    height: 3.14,
    rx: 0.24,
    ry: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 13.4,
    y: 93.43,
    width: 1.3,
    height: 5.07,
    rx: 0.37,
    ry: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M13.76,93.58h.38c.14,0,.25.11.25.25v2.89c0,.14-.11.25-.25.25h-.38c-.14,0-.25-.11-.25-.25v-2.89c0-.14.11-.25.25-.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 15.41,
    y: 92.99,
    width: 1.3,
    height: 5.51,
    rx: 0.38,
    ry: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 15.52,
    y: 93.16,
    width: 0.87,
    height: 3.67,
    rx: 0.26,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 17.41,
    y: 92.61,
    width: 1.3,
    height: 5.89,
    rx: 0.4,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 17.53,
    y: 92.78,
    width: 0.87,
    height: 3.93,
    rx: 0.26,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 19.42,
    y: 92.15,
    width: 1.3,
    height: 6.35,
    rx: 0.41,
    ry: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M19.81,92.34h.32c.15,0,.27.12.27.27v3.68c0,.15-.12.27-.27.27h-.32c-.15,0-.27-.12-.27-.27v-3.68c0-.15.12-.27.27-.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 21.42,
    y: 91.47,
    width: 1.3,
    height: 6.67,
    rx: 0.42,
    ry: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M21.82,91.67h.31c.16,0,.28.13.28.28v3.89c0,.16-.13.28-.28.28h-.31c-.16,0-.28-.13-.28-.28v-3.89c0-.16.13-.28.28-.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 23.43,
    y: 91.05,
    width: 1.3,
    height: 6.8,
    rx: 0.43,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 23.54,
    y: 91.26,
    width: 0.87,
    height: 4.54,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 25.43,
    y: 90.61,
    width: 1.3,
    height: 6.71,
    rx: 0.42,
    ry: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 25.55,
    y: 90.81,
    width: 0.87,
    height: 4.48,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 27.44,
    y: 90.18,
    width: 1.3,
    height: 6.5,
    rx: 0.42,
    ry: 0.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 27.55,
    y: 90.37,
    width: 0.87,
    height: 4.33,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 29.44,
    y: 89.82,
    width: 1.3,
    height: 6.01,
    rx: 0.4,
    ry: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 29.56,
    y: 90,
    width: 0.87,
    height: 4.01,
    rx: 0.27,
    ry: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 31.45,
    y: 89.82,
    width: 1.3,
    height: 4.72,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 31.56,
    y: 89.96,
    width: 0.87,
    height: 3.14,
    rx: 0.24,
    ry: 0.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 33.45,
    y: 89.17,
    width: 1.3,
    height: 4.3,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 33.57,
    y: 89.3,
    width: 0.87,
    height: 2.87,
    rx: 0.23,
    ry: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M35.77,88.66h.68c.17,0,.31.14.31.31v3.03c0,.17-.14.31-.31.31h-.68c-.17,0-.31-.14-.31-.31v-3.03c0-.17.14-.31.31-.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 35.57,
    y: 88.77,
    width: 0.87,
    height: 2.44,
    rx: 0.21,
    ry: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M12.32,93.34l-.56.12c-.2.04-.37-.09-.37-.29v-4.41c0-.21.16-.41.37-.45l.56-.12c.2-.04.37.09.37.29v4.41c0,.21-.16.41-.37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M12.13,91.82l-.38.08c-.14.03-.24-.06-.24-.2v-2.94c0-.14.11-.27.24-.3l.38-.08c.14-.03.24.06.24.2v2.94c0,.14-.11.27-.24.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M14.32,92.91l-.56.12c-.2.04-.37-.09-.37-.29v-4.41c0-.21.16-.41.37-.45l.56-.12c.2-.04.37.09.37.29v4.41c0,.21-.16.41-.37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M14.13,91.39l-.38.08c-.14.03-.24-.06-.24-.2v-2.94c0-.14.11-.27.24-.3l.38-.08c.14-.03.24.06.24.2v2.94c0,.14-.11.27-.24.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M16.32,92.48l-.56.12c-.2.04-.37-.09-.37-.29v-4.41c0-.21.16-.41.37-.45l.56-.12c.2-.04.37.09.37.29v4.41c0,.21-.16.41-.37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M16.12,90.95l-.38.08c-.14.03-.24-.06-.24-.2v-2.94c0-.14.11-.27.24-.3l.38-.08c.14-.03.24.06.24.2v2.94c0,.14-.11.27-.24.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M18.32,92.05l-.56.12c-.2.04-.37-.09-.37-.29v-4.41c0-.21.16-.41.37-.45l.56-.12c.2-.04.37.09.37.29v4.41c0,.21-.16.41-.37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M18.12,90.52l-.38.08c-.14.03-.24-.06-.24-.2v-2.94c0-.14.11-.27.24-.3l.38-.08c.14-.03.24.06.24.2v2.94c0,.14-.11.27-.24.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M20.32,91.62l-.56.12c-.2.04-.37-.09-.37-.29v-4.41c0-.21.16-.41.37-.45l.56-.12c.2-.04.37.09.37.29v4.41c0,.21-.16.41-.37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M20.12,90.09l-.38.08c-.14.03-.25-.06-.25-.2v-2.94c0-.14.11-.27.25-.3l.38-.08c.14-.03.25.06.25.2v2.94c0,.14-.11.27-.25.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M22.31,91.18l-.56.12c-.2.04-.37-.09-.37-.29v-4.41c0-.21.16-.41.37-.45l.56-.12c.2-.04.37.09.37.29v4.41c0,.21-.16.41-.37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M22.12,89.66l-.38.08c-.14.03-.24-.06-.24-.2v-2.94c0-.14.11-.27.24-.3l.38-.08c.14-.03.24.06.24.2v2.94c0,.14-.11.27-.24.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M24.31,90.75l-.56.12c-.2.04-.37-.09-.37-.29v-4.41c0-.21.16-.41.37-.45l.56-.12c.2-.04.37.09.37.29v4.41c0,.21-.16.41-.37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M24.12,89.23l-.38.08c-.14.03-.24-.06-.24-.2v-2.94c0-.14.11-.27.24-.3l.38-.08c.14-.03.24.06.24.2v2.94c0,.14-.11.27-.24.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M26.31,90.32l-.56.12c-.2.04-.37-.09-.37-.29v-4.41c0-.21.16-.41.37-.45l.56-.12c.2-.04.37.09.37.29v4.41c0,.21-.16.41-.37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M26.11,88.8l-.38.08c-.14.03-.24-.06-.24-.2v-2.94c0-.14.11-.27.24-.3l.38-.08c.14-.03.24.06.24.2v2.94c0,.14-.11.27-.24.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M28.31,89.89l-.56.12c-.2.04-.37-.09-.37-.29v-4.41c0-.21.16-.41.37-.45l.56-.12c.2-.04.37.09.37.29v4.41c0,.21-.16.41-.37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M28.11,88.36l-.38.08c-.14.03-.25-.06-.25-.2v-2.94c0-.14.11-.27.25-.3l.38-.08c.14-.03.24.06.24.2v2.94c0,.14-.11.27-.24.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M30.3,89.46l-.56.12c-.2.04-.37-.09-.37-.29v-4.41c0-.21.16-.41.37-.45l.56-.12c.2-.04.37.09.37.29v4.41c0,.21-.16.41-.37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M30.11,87.93l-.38.08c-.14.03-.24-.06-.24-.2v-2.94c0-.14.11-.27.24-.3l.38-.08c.14-.03.25.06.25.2v2.94c0,.14-.11.27-.25.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M32.3,89.02l-.56.12c-.2.04-.37-.09-.37-.29v-4.41c0-.21.16-.41.37-.45l.56-.12c.2-.04.37.09.37.29v4.41c0,.21-.16.41-.37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M32.11,87.5l-.38.08c-.14.03-.24-.06-.24-.2v-2.94c0-.14.11-.27.24-.3l.38-.08c.14-.03.24.06.24.2v2.94c0,.14-.11.27-.24.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M34.3,88.59l-.56.12c-.2.04-.37-.09-.37-.29v-4.41c0-.21.16-.41.37-.45l.56-.12c.2-.04.37.09.37.29v4.41c0,.21-.16.41-.37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M34.1,87.07l-.38.08c-.14.03-.24-.06-.24-.2v-2.94c0-.14.11-.27.24-.3l.38-.08c.14-.03.25.06.25.2v2.94c0,.14-.11.27-.25.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M36.3,88.16l-.56.12c-.2.04-.37-.09-.37-.29v-4.41c0-.21.16-.41.37-.45l.56-.12c.2-.04.37.09.37.29v4.41c0,.21-.16.41-.37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M36.1,86.64l-.38.08c-.14.03-.24-.06-.24-.2v-2.94c0-.14.11-.27.24-.3l.38-.08c.14-.03.24.06.24.2v2.94c0,.14-.11.27-.24.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 37.26,
    y: 82.05,
    width: 1.32,
    height: 9,
    rx: 0.49,
    ry: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 37.37,
    y: 82.31,
    width: 0.88,
    height: 6,
    rx: 0.33,
    ry: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 39.29,
    y: 81.72,
    width: 1.32,
    height: 7.28,
    rx: 0.44,
    ry: 0.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 39.4,
    y: 81.94,
    width: 0.88,
    height: 4.85,
    rx: 0.3,
    ry: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M41.71,81.3h.53c.22,0,.39.18.39.39v4.96c0,.22-.18.39-.39.39h-.53c-.22,0-.39-.18-.39-.39v-4.96c0-.22.18-.39.39-.39Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 41.43,
    y: 81.47,
    width: 0.88,
    height: 3.83,
    rx: 0.26,
    ry: 0.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 43.35,
    y: 80.81,
    width: 1.32,
    height: 3.86,
    rx: 0.32,
    ry: 0.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 43.46,
    y: 80.93,
    width: 0.88,
    height: 2.57,
    rx: 0.22,
    ry: 0.22
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-218"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M21.71,90.72c0,3.04,1.97,5.51,4.39,5.51s4.39-2.47,4.39-5.51-1.97-5.51-4.39-5.51-4.39,2.47-4.39,5.51Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-201",
    cx: 27.63,
    cy: 89,
    rx: 1.94,
    ry: 2.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M31.13,87.89c0,2.35,1.52,4.26,3.4,4.26s3.4-1.91,3.4-4.26-1.52-4.26-3.4-4.26-3.4,1.91-3.4,4.26Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-201",
    cx: 35.7,
    cy: 86.56,
    rx: 1.5,
    ry: 1.89
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-213"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.06,142.08c0-.44.03-.87.03-1.31,0-35.77-24.26-64.76-54.19-64.76s-54.19,28.99-54.19,64.76c0,.14,0,.27,0,.41l12.09,3.12c-.07-1.43-.12-5.09-.12-6.55,0-33.68,18.9-52.31,42.21-52.31s42.21,18.63,42.21,52.31c0,1.46-.05,5.12-.12,6.55l12.07-2.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-210"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M429.9,140.25c-.23-35.53-24.39-64.24-54.18-64.24s-54.19,28.99-54.19,64.76c0,.44.02.87.03,1.31l12.14,2.22c-.07-1.43-.12-5.09-.12-6.55,0-33.68,18.9-52.31,42.21-52.31s42.21,18.63,42.21,52.31c0,1.46-.05,5.12-.12,6.55l12.02-4.04Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-205"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M319.39,136.2c0-1.88-2.9-3.37-6.36-3.29l-153.06,4.19c-1.03.03-1.83.44-2.02.96l161.42-1.75s.02-.08.02-.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-208"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.95,114.77c.66,2,2.28,3.54,4.31,4.09,9.53,2.56,23.05,3.95,42.02,1.98l123.69-5.65c3.3-.15,6.22-2.2,7.48-5.26h0c9.45-23.04,28.71-37.36,50.27-37.36-23.55-.37-195.15,6.21-235.85,25.39,3.33,5.04,6.07,10.69,8.08,16.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-205"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-212"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M182.14,38.71h-.59c-7.02,0-12.91,4.39-14.65,10.35,0,0,8.89-1.1,14.36-2.89,2.39-.78,3.83-3.37,3.02-5.76-.33-.96-.96-1.7-2.13-1.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M182.14,62.03l-.59-.68c-2.45-2.81-4.75-4.92-6.8-6.32l-10.8.08c-.02.48.13,1.16.5,2,.91,2.08,2.57,4.03,3.56,4.26l1.75.4,11.58,13.31c4.1,4.71,4.95,2.62,4.95-1.15v-1.58c0-3.07-.81-6.49-4.15-10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M445.94,47.42c-10.5-8.37-38.74-23.96-56.74-31.73,4.76,13.72,36.56,29.78,56.74,31.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M251.8,39.84l4.43-18.5c.48-2-1.29-3.87-3.58-3.77-11.55.52-21.08,1.41-24.38,2.54-15.1,5.17-28.86,11.86-38.95,17.32-2.93,1.59-1.83,5.62,1.58,5.79,19.28.99,38.57.6,57.79-.92,1.53-.12,2.79-1.13,3.11-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M320.8,18.95c-7.55-1.4-22.19-1.97-37.43-1.92-2.27,0-4.18,1.51-4.47,3.52l-2.31,16.24c-.3,2.14,1.78,3.96,4.16,3.62,20.2-2.89,40.26-6.77,60.11-11.4,2.35-.55,2.59-3.47.35-4.31-5.69-2.14-12.71-4.33-20.41-5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M260.68,11.06h0c-18.63.73-32.43,2.19-36.92,3.91-38.73,14.82-70.8,38.61-71.12,38.85-.34.25-.48.69-.35,1.1.13.4.51.68.93.68.59,0,59.86-.03,98.94-2.37.44-.03.81-.35.9-.78l8.62-40.2c.06-.29-.01-.61-.21-.84-.18-.22-.48-.35-.79-.35ZM251.29,51.3c-24.43,1.44-56.29,2-78.72,2.21h-.03c-.74,0-1.44-.29-1.97-.81-.01-.01-.02-.02-.03-.03h-.8l-1.75,1.61c-1,.92-2.65.86-3.56-.17-.8-.89-.62-2.23.26-3.04l2.19-2.01c.18-.62.41-1.21.68-1.79.03-.07.06-.14.09-.21.26-.55.57-1.08.9-1.59.05-.08.1-.16.16-.24.35-.51.72-.99,1.14-1.45.05-.06.1-.11.15-.16.44-.47.91-.93,1.41-1.34,0,0,.01-.01.02-.01,1.07-.88,2.28-1.62,3.59-2.2.01,0,.02-.01.04-.02.65-.28,1.32-.52,2.02-.72.02,0,.05-.01.07-.02.7-.2,1.42-.35,2.16-.45,0,0,0,0,0,0,12.08-7.1,27.97-15.49,45.15-22.06,4.19-1.6,17.28-3,35.03-3.73l-8.19,38.22ZM362.14,26.73c-6.66-3.6-20.25-10.14-36.37-13.48-8.69-1.8-26.78-2.71-48.42-2.48-.43,0-.79.32-.84.75l-4.97,39.07c-.03.26.05.51.23.7.16.17.38.26.62.26.02,0,.05,0,.07,0,33.8-2.89,69.24-6.71,76.04-7.94,4.47-.81,10.37-5.41,14.52-9.13,1.17-1.04,1.75-2.59,1.57-4.13-.18-1.55-1.08-2.87-2.45-3.61ZM332.23,43.97c-14.2,1.61-35.82,3.81-58.86,5.79l4.75-37.28c21.18-.22,38.84.7,47.31,2.45,2.33.48,4.6,1.04,6.81,1.64v27.4ZM361.88,33.2c-5.65,5.05-10.51,8.14-13.69,8.72-1.99.36-7.05,1.02-14.25,1.85v-26.73c12.11,3.47,22.02,8.3,27.39,11.2.88.48,1.45,1.32,1.57,2.31.12,1.01-.25,1.98-1.01,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M160.13,132.27c-2.74,0-3.99-1.54-5.31-4.35-3.48-7.41-9.48-25.52-10.62-63.52-.11-3.72.86-6.81,2.8-8.94h0c12.73-13.97,69.09-43.03,84.34-45.01.39-.05,39-4.97,91.64-1.43,9.18.62,36.62,11.32,51.07,21.01,1.02.68,1.8,2.46,2.26,5.13,1.4,8.15-.4,24.56-6.51,32.75-.82,1.1-1.97,2.05-3.42,2.82-8.5,4.51-36.73,21.67-43.09,52.79-.37,1.81-1.93,3.12-3.79,3.18l-159.1,5.57c-.09,0-.18,0-.27,0ZM147.32,55.74c-1.87,2.05-2.8,5.04-2.69,8.64,1.14,37.92,7.12,55.97,10.58,63.35,1.27,2.7,2.39,4.1,4.92,4.1.08,0,.17,0,.25,0l159.1-5.57c1.66-.06,3.05-1.23,3.38-2.84,6.4-31.31,34.77-48.54,43.31-53.08,1.39-.74,2.5-1.65,3.28-2.7,6.04-8.1,7.82-24.34,6.44-32.42-.44-2.55-1.15-4.23-2.08-4.84-14.41-9.66-41.74-20.32-50.87-20.94-52.59-3.53-91.17,1.38-91.55,1.43-15.2,1.98-71.39,30.94-84.07,44.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M269.89,8.1c-1.68,8.14-11.38,57.67-12.93,120.54h.52c1.55-63.11,11.33-112.75,12.94-120.54h-.52Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/Car.4f5c0ca1070c679b3e9842832d04a166.svg";
export { ForwardRef as ReactComponent };